@if (bontonPanel.isB2B()) {
<div class="flex flex-col flex-auto min-w-0 min-h-[calc(100vh-16rem)]">
  <form [formGroup]="formGroup" class="px-4 pt-5 white-bg rounded-lg -mt-20 shadow pb-5 relative"
    [class]="!wlSettingsDetails.is_wl ? 'pb-7' : ''">
    <div class="grid grid-cols-12 space-x-3 mt-3 mb-7">
      <div class="p-3 field-blue-bg rounded-lg col-span-3 cursor-pointer" (click)="onDestinationSelect.open()">
        <span class="text-gray text-md">Destination</span>
        <mat-select #onDestinationSelect class="font-semibold" [compareWith]="compareWith"
          formControlName="country_code">
          <mat-option>
            <ngx-mat-select-search placeholderLabel="Search Country" noEntriesFoundLabel="'No matching Country found'"
              formControlName="destinationfilter">
            </ngx-mat-select-search>
          </mat-option>
          @for (country of countryList; track country) {
          <mat-option [value]="country">
            <span class="font-medium">{{ country.description }}</span>
          </mat-option>
          }
        </mat-select>
      </div>
      <div class="field-blue-bg rounded-lg p-3 col-span-2 cursor-pointer" (click)="picker.open()">
        <span class="text-gray text-md">Start Date</span>
        <div class="flex flex-row">
          <input class="font-semibold" [min]="minDate" [readonly]="true" [matDatepicker]="picker"
            formControlName="depart_date_time" (dateChange)="onDateTimeChange($event, 'departDate')" />
        </div>
        <mat-datepicker #picker></mat-datepicker>
      </div>
      <div class="field-blue-bg rounded-lg p-3 col-span-2 cursor-pointer" (click)="picker2.open()">
        <span class="text-gray text-md">End Date</span>
        <div class="flex flex-row">
          <input class="font-semibold" [min]="minDateReturn" [readonly]="true" [matDatepicker]="picker2"
            formControlName="return_date_time" (dateChange)="onDateTimeChange($event, 'returnDate')" />
        </div>
        <mat-datepicker #picker2></mat-datepicker>
      </div>
      <div class="p-3 field-blue-bg rounded-lg col-span-2" (mouseleave)="SetDefaultDate()">
        <div class="text-gray text-md">Duration</div>
        <input appDurationChange formControlName="duration" class="font-semibold" matInput [value]="travelDuration"
          (blur)="SetDefaultDate()" />
      </div>
      <div class="col-span-3 relative field-blue-bg rounded-lg cursor-pointer" #containerRef>
        <div class="flex flex-col p-3" (click)="openTraveller()" #travellerRef>
          <span class="text-md text-gray">Travellers</span>
          <div class="truncate pr-3 w-full rounded-md font-Roboto font-bold">
            <span class="text-[14px]">
              {{ formGroup.get('age_list').value?.length ? formGroup.get('age_list').value.length + ' Pax' :
              'Select Traveller' }}
            </span>
          </div>
        </div>
        @if (selectedField === 'travellers') {
        <div class="bg-white rounded-3xl w-[290px] p-[1.6rem] absolute round-shadow z-[99]" #paxdetails
          [ngClass]="paxPopAbove?'bottom-[122px]':'top-[70px]'">
          <app-add-traveller-modal class="text-black" [paxData]="{ data: this.formGroup.value }"
            (OnClose)="patchPaxData($event)"></app-add-traveller-modal>
        </div>
        }
      </div>
    </div>
    @if(!wlSettingsDetails.is_wl) {
    <div class="flex justify-end absolute right-4 bottom-2" (click)="helpVideo('insurance')">
      <div class="flex items-center gap-2 px-4 py-2 rounded-full cursor-pointer hover:bg-[#E8F1F8]">
        <span class="font-medium primary-text text-sm">NEED HELP?</span>
        <mat-icon svgIcon="youtube" class="icon-size-5"></mat-icon>
      </div>
    </div>
    }
    <div class="flex flex-row justify-center items-center -mb-13 mt-2">
      <button mat-flat-button class="primary-bg w-50  min-h-13 rounded-lg  insurance-search-button" (click)="detail()"
        (mouseover)="SetDefaultDate()">
        <span class="white-text font-semibold text-lg">Search</span>
      </button>
    </div>
  </form>
  <!-- recent insurance search section -->
  @if (recentInsuranceSearchList?.length) {
  <div class="flex flex-col mt-12">
    <div>
      <div class="text-2xl font-bold">Recent Insurance Search</div>
    </div>
    <div class="mt-1 flex flex-wrap">
      @for (rs of recentInsuranceSearchList; track rs) {
      <div
        class="white-bg flex rounded-lg p-3 shadow-[0_0_15px_0_rgba(167,167,167,0.2)] w-[32.33%] mx-[0.5%] mt-3 cursor-pointer"
        (click)="recentSearch(rs)">
        <div class="w-[80px] flex justify-center">
          <div class="field-blue-bg rounded-full w-[64px] h-[64px] flex items-center justify-center">
            <img loading="lazy" src="assets\images\insurance\insurance-vector.svg" alt="insurance-vector"
              class="w-8 object-contain">
          </div>
        </div>
        <div class="w-[calc(100%-100px)] pl-1">
          <div class="font-semibold primary-text">{{rs.destination}}</div>
          <div class="text-gray text-sm pt-1 flex justify-between items-center">
            <span>{{rs.departDate | date:'dd MMM yyyy'}} - {{rs.returnDate |
              date:'dd MMM yyyy'}}</span>
            <span class="font-medium text-black">{{rs.totalDays}} Days</span>
          </div>
          <div class="text-md">starting at <span class="font-semibold text-base">{{rs.currency}}
              {{rs.insRate}}</span></div>
        </div>
      </div>
      }
    </div>
  </div>
  }
</div>
} @else {
@if (insuranceData?.is_active) {
@switch (wlSettingsDetails?.theme?.wl_theme) {
<!-- *ngSwitchCase="themes.theme1" -->
@case (themes.theme1) {
<div class="flex flex-col justify-center w-full items-center mobile:hidden tablet:hidden">
  <div class="bg-cover flex flex-col bg-center bg-no-repeat h-[540px] primary-bg w-full gray-text" style="background-image: url('{{insuranceData?.background_image}}');background-blend-mode: color !important;
                background-color: #0000007a !important;">
    <div class="flex flex-col h-full items-center justify-center max-h-[29.5rem]">
      <div class="flex flex-col">
        <div class="flex">
          <h1
            class="text-center text-[52px] justify-center font-bold font-Racing_Sans_One white-text flex w-full z-[99] tracking-[4px]">
            {{insuranceData?.title}}</h1>
        </div>
        <div class="flex text-xl justify-center font-Ibm_Plex_Sans_Devanagari white-text">
          <div class="text-center w-[1000px] z-[99] textNote4">
            {{insuranceData?.description}}</div>
        </div>
      </div>
    </div>
  </div>
  <div class="pt-3">
    <div class="min-w-[1260px] max-w-[1260px] m-auto mt-[-68px] relative z-[99]">
      <div class="m-auto rounded-[10px]">
        <form [formGroup]="formGroup" class="flex flex-col rounded-[10px]">
          <div class="flex flex-row w-full white-bg overflow-visible rounded-[10px] shadow-xl">
            <div class="flex flex-row w-full">
              <div class="flex flex-col border-r gray-border pl-0 py-[25px] cursor-pointer"
                [ngClass]="selectedField == 'destination' ? 'secondary-bg' : ''" (click)="Destination.open()">
                <span class="font-normal text-[15px] ml-6 font-Roboto text-secondary">Destination</span>
                <mat-select (click)="selectedField = 'destination'" #Destination
                  class="ml-[22px] custom_dropdown_arrow pt-3 w-[273px] font-bold rounded-[5px] pr-[15px] pl-[15xp] text-xl"
                  formControlName="country_code" [compareWith]="compareWith">
                  <mat-option>
                    <ngx-mat-select-search placeholderLabel="Search Destination"
                      noEntriesFoundLabel="'no matching destination found'" formControlName="destinationfilter">
                    </ngx-mat-select-search>
                  </mat-option>
                  @for (ct of countryList; track ct) {
                  <mat-option [value]="ct">
                    <div class="flex flex-col truncate max-w-full justify-center">
                      <span class="font-normal text-base">{{ct.description}}
                      </span>
                    </div>
                  </mat-option>
                  }
                </mat-select>
              </div>
              <div class="flex flex-col pl-[15px] w-[170px] border-r gray-border cursor-pointer"
                [ngClass]="selectedField == 'depart_date_time' ? 'secondary-bg' : ''" (click)="picker2.open()">
                <div class="ml-[7px] py-[25px]">
                  <mat-label class="white-text text-[15px] items-center gap-1 flex">
                    <span class="pt-1 pb-1 pr-1"><img loading="lazy" class="w-5" src="assets/images/b2c/date_icon.webp"
                        alt="date_icon"></span>
                    <span class="ml-0 pr-3 pt-[2px] text-secondary">Start Date</span>
                  </mat-label>
                  <input readonly class="font-Roboto font-bold text-xl pt-2 cursor-pointer max-w-[135px]" matInput
                    [matDatepicker]="picker2" [min]="minDate"
                    (click)="picker2.open();selectedField = 'depart_date_time'" formControlName="depart_date_time"
                    (dateChange)="onDateTimeChange($event, 'departDate')">
                  <mat-datepicker-toggle matSuffix [for]="picker2" class="hidden"></mat-datepicker-toggle>
                  <mat-datepicker #picker2></mat-datepicker>
                </div>
              </div>
              <div class="flex flex-col pl-[15px] w-[170px] border-r gray-border cursor-pointer"
                [ngClass]="selectedField == 'return_date_time' ? 'secondary-bg' : ''" (click)="pickerOne.open()">
                <div class="ml-[7px] py-[25px]">
                  <mat-label class="white-text text-[15px] items-center gap-1 flex">
                    <span class="pt-1 pb-1 pr-1"><img loading="lazy" class="w-5" src="assets/images/b2c/date_icon.webp"
                        alt="date_icon"></span>
                    <span class="ml-0 pr-3 pt-[2px] text-secondary">End Date</span>
                  </mat-label>
                  <input readonly class="font-Roboto font-bold text-xl pt-2 cursor-pointer max-w-[135px]" matInput
                    [matDatepicker]="pickerOne" [min]="minDateReturn"
                    (click)="pickerOne.open();selectedField = 'return_date_time'"
                    (dateChange)="onDateTimeChange($event, 'returnDate')" formControlName="return_date_time">
                  <mat-datepicker-toggle matSuffix [for]="pickerOne" class="hidden"></mat-datepicker-toggle>
                  <mat-datepicker #pickerOne></mat-datepicker>
                </div>
              </div>
              <div class="flex flex-col white-text py-[25px] min-w-[200px] border-r gray-border"
                [ngClass]="selectedField == 'duration' ? 'secondary-bg' : ''">
                <span class="font-normal text-[15px] ml-6 font-Roboto text-secondary">Duration</span>
                <input appDurationChange formControlName="duration" (click)="selectedField = 'duration'"
                  class="font-semibold" matInput [value]="travelDuration"
                  class="ml-[22px] pt-3 font-bold text-black rounded-[5px] pr-[15px] pl-[15xp] text-xl" />
              </div>
              <div class="min-w-[250px] relative" #containerRef>
                <div class="flex flex-col pt-[28px] pb-[29px] pl-4 traveller-div cursor-pointer"
                  [ngClass]="selectedField == 'travellers' ? 'secondary-bg' : ''" #travellerRef
                  (click)="openTraveller()">
                  <span class="text-[15px] rounded-lg w-full h-[24px] text-secondary">Travellers</span>
                  <div class="truncate pr-3 w-full font-Roboto font-bold text-xl pt-[8px] cursor-pointer">
                    {{ formGroup.get('age_list').value?.length ?
                    formGroup.get('age_list').value.length + ' Pax' :
                    'Select Traveller' }}
                  </div>
                </div>
                @if (selectedField === 'travellers') {
                <div class="bg-white rounded-3xl w-[290px] p-[1.6rem] absolute round-shadow z-[99]" #paxdetails
                  [ngClass]="paxPopAbove?'bottom-[122px]':'top-[122px]'">
                  <app-add-traveller-modal class="text-black"
                    [paxData]="{ data: this.formGroup.value, roomdata: this.roomData }"
                    (OnClose)="patchPaxData($event)"></app-add-traveller-modal>
                </div>
                }
              </div>
              <div class="w-full h-full justify-end pr-5 flex items-center" (mouseover)="SetDefaultDate()">
                <button class="primary-bg rounded-lg py-10 px-12 insurance-search-button" mat-flat-button
                  (click)="detail()">
                  <span class="white-text font-semibold text-2xl font-Roboto">Search</span>
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
}
<!--Theme 2 -->
@case (themes.theme2) {
<div class="flex flex-col justify-center w-full items-center mobile:hidden tablet:hidden">
  <div class="bg-cover flex flex-col bg-center bg-no-repeat h-[375px] primary-bg w-full gray-text" style="background-image: url('{{insuranceData?.background_image}}');background-blend-mode: color !important;
background-color: #0000007a !important;">
    <div class="flex flex-col h-full items-center justify-center max-h-[16.5rem]">
      <div class="flex flex-col">
        <div class="flex">
          <h1 class="text-center text-[52px] justify-center font-bold font-Dosis white-text flex w-full z-[99]">
            {{insuranceData?.title}}</h1>
        </div>
        <div class="flex text-xl justify-center font-Ibm_Plex_Sans_Devanagari white-text">
          <div class="text-center w-[1000px] z-[99] textNote4">
            {{insuranceData?.description}}</div>
        </div>
      </div>
    </div>
  </div>
  <div class="min-w-[1260px] max-w-[1260px] z-[99] mt-[-110px] rounded-[15px]">
    <div class="mr-6 rounded-[15px] min-w-[1260px] max-w-[1260px]">
      <form [formGroup]="formGroup" class="flex flex-col px-4 pt-6 white-bg rounded-[15px] shadow-xl pb-5">
        <div class="flex flex-row w-full space-x-3 mt-3 mb-5">
          <div
            class="flex flex-col min-w-[28%] max-w-[28%] h-[60px] border-2 pt-0 pb-3 pl-3 pr-3 rounded-lg cursor-pointer"
            [ngClass]="selectedField == 'destination' ? 'primary-border' : 'gray-border'" (click)="Destination.open()">
            <span class="text-[15px] mt-[-11px] font-Roboto white-bg px-[10px] max-w-max font-medium"
              [ngClass]="selectedField == 'destination' ? 'primary-text' : 'text-secondary'">Destination</span>
            <mat-select (click)="selectedField = 'destination'" #Destination
              class="mt-1 pl-2 font-bold font-Roboto text-2xl theme-black-text" [compareWith]="compareWith"
              formControlName="country_code">
              <mat-option>
                <ngx-mat-select-search placeholderLabel="Search Destination"
                  noEntriesFoundLabel="'no matching destination found'" formControlName="destinationfilter">
                </ngx-mat-select-search>
              </mat-option>
              @for (ct of countryList; track ct) {
              <mat-option [value]="ct">
                <div class="flex flex-col truncate max-w-full h-15 justify-center">
                  <span class="font-normal text-base">{{ct.description}}
                  </span>
                </div>
              </mat-option>
              }
            </mat-select>
          </div>
          <div [ngClass]="selectedField == 'depart_date_time' ? 'primary-border' : 'gray-border'"
            class="flex flex-col w-[22%] h-[60px] white-bg rounded-lg pb-3 pr-3 border-2 cursor-pointer"
            (click)="picker.open()">
            <span class="text-[15px] mt-[-11px] ml-2 font-Roboto white-bg px-[5px] max-w-max font-medium"
              [ngClass]="selectedField == 'depart_date_time' ? 'primary-text' : 'text-secondary'">Start
              Date</span>
            <div class="flex flex-row pl-3">
              <input class="font-bold text-2xl font-Roboto max-w-[9rem] theme-black-text mt-1" [min]="minDate"
                (click)="picker.open(); selectedField = 'depart_date_time'" [readonly]="true"
                (dateChange)="onDateTimeChange($event, 'departDate')" [matDatepicker]="picker"
                formControlName="depart_date_time" />
            </div>
            <mat-datepicker #picker></mat-datepicker>
          </div>
          <div [ngClass]="selectedField == 'return_date_time' ? 'primary-border' : 'gray-border'"
            class="flex flex-col w-[22%] h-[60px] white-bg rounded-lg pb-3 pr-3 border-2 cursor-pointer"
            (click)="pickerOne.open()">
            <span class="text-[15px] mt-[-11px] ml-2 font-Roboto white-bg px-[5px] max-w-max font-medium"
              [ngClass]="selectedField == 'return_date_time' ? 'primary-text' : 'text-secondary'">End
              Date</span>
            <div class="flex flex-row pl-3">
              <input class="font-bold text-2xl font-Roboto max-w-[9rem] theme-black-text mt-1" [min]="minDateReturn"
                (click)="pickerOne.open(); selectedField = 'return_date_time'"
                (dateChange)="onDateTimeChange($event, 'returnDate')" [readonly]="true" [matDatepicker]="pickerOne"
                formControlName="return_date_time" />
            </div>
            <mat-datepicker #pickerOne></mat-datepicker>
          </div>
          <div class="flex flex-col min-w-[20%] max-w-[20%] h-[60px] pt-0 py-3 px-2 rounded-lg border-2"
            [ngClass]="selectedField == 'duration' ? 'primary-border' : 'gray-border'">
            <span class="text-[15px] mt-[-11px] font-Roboto white-bg px-2 max-w-max font-medium"
              [ngClass]="selectedField == 'duration' ? 'primary-text' : 'text-secondary'">Duration</span>
            <div class="flex flex-row">
              <input appDurationChange formControlName="duration" (click)="selectedField = 'duration'" matInput
                [value]="travelDuration" class="mt-1 pl-2 w-[94%] font-bold text-2xl font-Roboto theme-black-text" />
            </div>
          </div>
          <div class="min-w-[20%] max-w-[20%] relative" #containerRef>
            <div
              class="flex flex-col flex-grow p-3 pl-0 white-bg rounded-lg border-2 h-[60px] traveller-div cursor-pointer"
              [ngClass]="selectedField == 'travellers' ? 'primary-border' : 'gray-border'" #travellerRef
              (click)="openTraveller()">
              <span [ngClass]="selectedField == 'travellers' ? 'primary-text' : 'text-secondary'"
                class="font-Roboto white-bg ml-2 px-[5px] max-w-max font-medium text-[15px] mt-[-23px]">Travellers</span>
              <span class="font-bold pl-3 text-2xl font-Roboto theme-black-text pt-1">{{
                formGroup.get('age_list').value?.length ?
                formGroup.get('age_list').value.length + ' Pax' :
                'Select Traveller' }}</span>
            </div>
            @if (selectedField === 'travellers') {
            <div class="bg-white rounded-3xl w-[290px] p-[1.6rem] absolute round-shadow z-[99] right-0" #paxdetails
              [ngClass]="paxPopAbove?'bottom-[73px]':'top-[66px]'">
              <app-add-traveller-modal class="text-black"
                [paxData]="{ data: this.formGroup.value, roomdata: this.roomData }"
                (OnClose)="patchPaxData($event)"></app-add-traveller-modal>
            </div>
            }
          </div>
        </div>
        <div class="flex flex-row justify-center items-center mb-[-45px] space-x-4" (mouseover)="SetDefaultDate()">
          <button mat-flat-button class="w-60 min-h-13 rounded-full primary-bg insurance-search-button"
            (click)="detail()">
            <span class="white-text font-semibold text-2xl font-Inter">Search</span>
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
}
<!--Theme 3 -->
@case (themes.theme3) {
<div class="flex flex-col justify-center w-full items-center mobile:hidden tablet:hidden">
  <div class="bg-cover flex flex-col bg-center bg-no-repeat h-[375px] primary-bg w-full gray-text" style="background-image: url('{{insuranceData?.background_image}}');background-blend-mode: color !important;
background-color: #0000007a !important;">
    <div class="flex flex-col h-full items-center justify-center max-h-[18.5rem]">
      <div class="flex flex-col">
        <div class="flex">
          <h1 class="text-center text-[52px] justify-center font-bold font-Dosis white-text flex w-full z-[99]">
            {{insuranceData?.title}}</h1>
        </div>
        <div class="flex text-xl justify-center font-Ibm_Plex_Sans_Devanagari white-text">
          <div class="text-center w-[1000px] z-[99] textNote4">
            {{insuranceData?.description}}</div>
        </div>
      </div>
    </div>
  </div>
  <div class="min-w-[1260px] max-w-[1260px] z-[99] flex rounded-xl mt-[-75px]">
    <div class="mr-6 rounded-[10px] min-w-[1260px] max-w-[1260px]">
      <form [formGroup]="formGroup" class="flex flex-col px-4 pt-5 white-bg rounded-lg shadow-xl pb-5">
        <div class="flex flex-row w-full space-x-3 mt-3 mb-5">
          <div class="flex flex-col min-w-[28%] max-w-[28%] h-[74px] py-3 px-2 secondary-bg rounded-lg cursor-pointer"
            (click)="Destination.open()">
            <span class="text-lg secondary-bg px-[10px] max-w-max font-normal text-secondary">Destination</span>
            <mat-select class="mt-1 px-2 font-semibold text-xl" formControlName="country_code"
              [compareWith]="compareWith" #Destination>
              <mat-option>
                <ngx-mat-select-search placeholderLabel="Search Destination"
                  noEntriesFoundLabel="'no matching destination found'" formControlName="destinationfilter">
                </ngx-mat-select-search>
              </mat-option>
              @for (ct of countryList; track ct) {
              <mat-option [value]="ct">
                <div class="flex flex-col truncate max-w-full h-15 justify-center">
                  <span class="font-normal text-base">{{ct.description}}
                  </span>
                </div>
              </mat-option>
              }
            </mat-select>
          </div>
          <div class="flex flex-col w-[22%] h-[74px] secondary-bg rounded-lg px-3 py-2.5 cursor-pointer"
            (click)="picker.open()">
            <span class="max-w-max secondary-bg text-secondary text-lg font-normal">Start
              Date</span>
            <div class="flex flex-row">
              <input class="font-semibold text-xl mt-1 max-w-[120px]" [min]="minDate" (click)="picker.open()"
                [readonly]="true" [matDatepicker]="picker" formControlName="depart_date_time"
                (dateChange)="onDateTimeChange($event, 'departDate')" />
              <mat-icon svgIcon="mat_outline:date_range" class="primary-text mt-1 cursor-pointer"
                (click)="picker.open()"></mat-icon>
            </div>
            <mat-datepicker #picker></mat-datepicker>
          </div>
          <div class="flex flex-col w-[22%] h-[74px] secondary-bg rounded-lg px-3 py-2.5 cursor-pointer"
            (click)="pickerOne.open()">
            <span class="max-w-max secondary-bg text-secondary text-lg font-normal">End
              Date</span>
            <div class="flex flex-row">
              <input class="font-semibold text-xl mt-1 max-w-[120px]" [min]="minDateReturn" (click)="pickerOne.open()"
                [readonly]="true" [matDatepicker]="pickerOne" formControlName="return_date_time"
                (dateChange)="onDateTimeChange($event, 'returnDate')" />
              <mat-icon svgIcon="mat_outline:date_range" class="primary-text mt-1 cursor-pointer"
                (click)="pickerOne.open()"></mat-icon>
            </div>
            <mat-datepicker #pickerOne></mat-datepicker>
          </div>
          <div class="flex flex-col min-w-[20%] max-w-[20%] h-[74px] py-3 px-2 secondary-bg rounded-lg">
            <span class="text-lg secondary-bg px-[8px] max-w-max font-normal text-secondary">Duration</span>
            <div class="flex flex-row">
              <input appDurationChange formControlName="duration" (click)="selectedField = 'duration'" matInput
                [value]="travelDuration" class="mt-1 pl-2 font-semibold text-xl" />
            </div>
          </div>
          <div class="min-w-[20%] max-w-[20%] relative" #containerRef>
            <div
              class="flex flex-col min-w-[100%] max-w-[100%] h-[74px] py-3 px-2 secondary-bg rounded-lg traveller-div cursor-pointer"
              (click)="openTraveller()">
              <span class="text-lg secondary-bg px-[10px] max-w-max font-normal text-secondary">Travellers</span>
              <span class="pl-2 font-semibold text-xl mt-1 cursor-pointer" #travellerRef>{{
                formGroup.get('age_list').value?.length ?
                formGroup.get('age_list').value.length + ' Pax' :
                'Select Traveller' }}</span>
            </div>
            @if (selectedField === 'travellers') {
            <div class="bg-white rounded-3xl w-[290px] p-[1.6rem] absolute round-shadow z-[99] right-0" #paxdetails
              [ngClass]="paxPopAbove?'bottom-[80px]':'top-[80px]'">
              <app-add-traveller-modal class="text-black"
                [paxData]="{ data: this.formGroup.value, roomdata: this.roomData }"
                (OnClose)="patchPaxData($event)"></app-add-traveller-modal>
            </div>
            }
          </div>
        </div>
        <div class="flex flex-row justify-center items-center -mb-11 space-x-4" (mouseover)="SetDefaultDate()">
          <button mat-flat-button class="w-50 min-h-13 rounded-lg primary-bg insurance-search-button"
            (click)="detail()">
            <span class="white-text font-medium text-2xl">Search</span>
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
}
<!--Theme 4 -->
@case (themes.theme4) {
<div class="flex flex-col justify-center w-full items-center mobile:hidden tablet:hidden">
  <div class="bg-cover flex flex-col bg-center bg-no-repeat h-[375px] primary-bg w-full gray-text" style="background-image: url('{{insuranceData?.background_image}}');background-blend-mode: color !important;
background-color: #0000007a !important;">
    <div class="flex flex-col h-full items-center justify-center max-h-[14rem]">
      <div class="flex flex-col">
        <div class="flex">
          <h1 class="text-center text-[52px] justify-center font-bold font-Dosis white-text flex w-full z-[99]">
            {{insuranceData?.title}}</h1>
        </div>
        <div class="flex text-xl justify-center font-Ibm_Plex_Sans_Devanagari white-text">
          <div class="text-center w-[1000px] z-[99] textNote4">
            {{insuranceData?.description}}</div>
        </div>
      </div>
    </div>
  </div>
  <div class="min-w-[1260px] max-w-[1260px] z-[99] flex rounded-xl mt-[-95px]">
    <div class="mr-6 rounded-[10px] min-w-[1260px] max-w-[1260px]">
      <form [formGroup]="formGroup" class="flex flex-col px-4 pt-[6px] white-bg rounded-[22px] shadow-xl pb-5">
        <div class="flex flex-row w-full space-x-3 mt-3 mb-5">
          <div class="flex flex-col min-w-[28%] max-w-[28%] h-[74px] py-3 pr-2 pl-[17px] cursor-pointer"
            (click)="Destination.open()">
            <span class="text-lg pr-[8px] max-w-max font-normal text-secondary">Destination</span>
            <mat-select class="mt-1 pr-2 font-semibold text-xl" formControlName="country_code"
              [compareWith]="compareWith" #Destination>
              <mat-option>
                <ngx-mat-select-search placeholderLabel="Search Destination"
                  noEntriesFoundLabel="'no matching destination found'" formControlName="destinationfilter">
                </ngx-mat-select-search>
              </mat-option>
              @for (ct of countryList; track ct) {
              <mat-option [value]="ct">
                <div class="flex flex-col truncate max-w-full h-15 justify-center">
                  <span class="font-normal text-base">{{ct.description}}
                  </span>
                </div>
              </mat-option>
              }
            </mat-select>
            <div class="gray-border mt-[3px] w-full border-t-2"></div>
          </div>
          <div class="flex flex-col w-[22%] h-[74px] px-3 py-2.5 cursor-pointer" (click)="picker.open()">
            <span class="max-w-max text-secondary text-lg font-normal">Start Date</span>
            <div class="flex flex-row">
              <input class="font-semibold text-xl mt-1 max-w-[140px]" [min]="minDate" (click)="picker.open()"
                [readonly]="true" [matDatepicker]="picker" formControlName="depart_date_time"
                (dateChange)="onDateTimeChange($event, 'departDate')" />
            </div>
            <mat-datepicker #picker></mat-datepicker>
            <div class="gray-border mt-[3px] w-full border-t-2"></div>
          </div>
          <div class="flex flex-col w-[22%] h-[74px] px-3 py-2.5 cursor-pointer" (click)="pickerOne.open()">
            <span class="max-w-max text-secondary text-lg font-normal">End Date</span>
            <div class="flex flex-row">
              <input class="font-semibold text-xl mt-1 max-w-[140px]" [min]="minDateReturn" (click)="pickerOne.open()"
                [readonly]="true" [matDatepicker]="pickerOne" (dateChange)="onDateTimeChange($event, 'returnDate')"
                formControlName="return_date_time" />
            </div>
            <mat-datepicker #pickerOne></mat-datepicker>
            <div class="gray-border mt-[3px] w-full border-t-2"></div>
          </div>
          <div class="flex flex-col min-w-[20%] max-w-[20%] h-[74px] py-3 px-2">
            <span class="text-lg px-[8px] max-w-max font-normal text-secondary">Duration</span>
            <input appDurationChange formControlName="duration" matInput [value]="travelDuration"
              class="pl-2 pt-[2px] font-semibold theme-black-text text-xl" />
            <div class="gray-border mt-[3px] ml-2 w-full border-t-2"></div>
          </div>
          <div class="min-w-[20%] max-w-[20%] relative" #containerRef>
            <div
              class="flex flex-col flex-grow px-3 justify-end pt-2.5 h-[74px] min-w-[100%] max-w-[100%] traveller-div cursor-pointer"
              #travellerRef (click)="openTraveller()">
              <span class="max-w-max text-secondary text-lg font-normal pb-1">Travellers</span>
              <span class="font-semibold text-xl cursor-pointer">{{
                formGroup.get('age_list').value?.length ?
                formGroup.get('age_list').value.length + ' Pax' :
                'Select Traveller' }}</span>
              <div class="gray-border mt-[3px] w-full mb-1 border-t-2"></div>
            </div>
            @if (selectedField === 'travellers') {
            <div class="bg-white rounded-3xl w-[290px] p-[1.6rem] absolute round-shadow z-[99] right-0" #paxdetails
              [ngClass]="paxPopAbove?'bottom-[80px]':'top-[80px]'">
              <app-add-traveller-modal class="text-black"
                [paxData]="{ data: this.formGroup.value, roomdata: this.roomData }"
                (OnClose)="patchPaxData($event)"></app-add-traveller-modal>
            </div>
            }
          </div>
        </div>
        <div class="flex flex-row justify-center items-center -mb-[47px] space-x-4" (mouseover)="SetDefaultDate()">
          <button mat-flat-button class="w-60 min-h-13 rounded-full primary-bg insurance-search-button"
            (click)="detail()">
            <span class="white-text font-medium text-2xl">Search</span>
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
}
<!--Theme 5 -->
@case (themes.theme5) {
<div class="flex flex-col justify-center w-full items-center mobile:hidden tablet:hidden">
  <div class="bg-cover flex flex-row bg-center justify-center items-center bg-no-repeat h-[540px] primary-bg w-full"
    style="background-image: url('{{insuranceData?.background_image}}');background-blend-mode: color !important;
background-color: #000000b3 !important;">
    <div class="flex flex-row gap-6 min-w-[1260px] max-w-[1260px] h-full">
      <div class="flex flex-col h-full items-center justify-center w-1/2">
        <div class="flex flex-col gap-[2px]">
          <div class="flex">
            <h1
              class="text-center text-[52px] justify-center font-bold font-Racing_Sans_One white-text flex w-full z-[99] tracking-[4px]">
              {{insuranceData?.title}}</h1>
          </div>
          <div class="flex text-base justify-center font-Inter white-text">
            <div class="text-center w-[500px] z-[99] textNote4 font-normal gray-text">
              {{insuranceData?.description}}</div>
          </div>
        </div>
      </div>
      <div class="w-1/2 h-full flex flex-col">
        <form [formGroup]="formGroup" class="flex flex-col h-full w-full justify-center gap-3 theme5-form-field">
          <div class="flex flex-col white-bg rounded-lg shadow-xl p-5 w-full gap-5">
            <mat-form-field class="w-full">
              <mat-label class="text-secondary text-base font-normal">Destination</mat-label>
              <mat-select class="font-medium text-[15px] pr-1 max-w-[523px] text-black" [compareWith]="compareWith"
                formControlName="country_code">
                <mat-option>
                  <ngx-mat-select-search placeholderLabel="Search Destination"
                    noEntriesFoundLabel="'no matching destination found'" formControlName="destinationfilter">
                  </ngx-mat-select-search>
                </mat-option>
                @for (ct of countryList; track ct) {
                <mat-option [value]="ct">
                  <div class="flex flex-col truncate max-w-full h-15 justify-center">
                    <span class="font-normal text-base">
                      {{ct.description}}</span>
                  </div>
                </mat-option>
                }
              </mat-select>
              <mat-icon svgIcon="feather:map-pin" class="icon-size-5 gray-text"></mat-icon>
            </mat-form-field>
            <div class="flex flex-row gap-3 w-full">
              <mat-form-field class="w-1/2">
                <mat-label class="text-secondary text-base font-normal">Start
                  Date</mat-label>
                <input matInput class="font-medium text-[15px] text-black" [min]="minDate" (click)="picker.open()"
                  [readonly]="true" [matDatepicker]="picker" formControlName="depart_date_time"
                  (dateChange)="onDateTimeChange($event, 'departDate')" />
                <mat-datepicker #picker></mat-datepicker>
                <mat-icon svgIcon="feather:calendar" class="icon-size-5 gray-text" (click)="picker.open()"></mat-icon>
              </mat-form-field>
              <mat-form-field class="w-1/2">
                <mat-label class="text-secondary text-base font-normal">End Date</mat-label>
                <input matInput class="font-medium text-[15px] text-black" [min]="minDateReturn"
                  (click)="picker2.open()" [readonly]="true" [matDatepicker]="picker2"
                  formControlName="return_date_time" (dateChange)="onDateTimeChange($event, 'returnDate')" />
                <mat-datepicker #picker2></mat-datepicker>
                <mat-icon svgIcon="feather:calendar" class="icon-size-5 gray-text" (click)="picker2.open()"></mat-icon>
              </mat-form-field>
            </div>
            <div class="flex flex-row gap-3">
              <mat-form-field class="w-1/2">
                <mat-label class="text-secondary text-base font-normal">Duration</mat-label>
                <input appDurationChange formControlName="duration" (click)="selectedField = 'duration'" matInput
                  [value]="travelDuration" class="font-medium text-[15px] w-[230px] pr-1 text-black" />
                <img loading="lazy" src="assets/images/b2c/length_of_stay.svg" alt="length_of_stay"
                  class="h-5 w-5 gray-text">
              </mat-form-field>
              <div class="flex flex-col w-1/2 relative" #containerRef>
                <div class="flex flex-col h-[74px] traveller-div cursor-pointer" (click)="openTraveller()"
                  #travellerRef>
                  <span class="text-secondary text-base font-normal pb-[4px] leading-5">Travellers</span>
                  <span
                    class="font-medium text-[15px] cursor-pointer theme-black-text rounded-md border-[1px] py-[12px] px-4 flex flex-row justify-between"
                    [ngClass]="selectedField === 'travellers' ? 'border-[#4f46e5]' :'border-[#737373]'">{{
                    formGroup.get('age_list').value?.length ?
                    formGroup.get('age_list').value.length + ' Pax' :
                    'Select Traveller' }}
                    <mat-icon svgIcon="feather:user" class="icon-size-5 gray-text"></mat-icon>
                  </span>
                </div>
                @if (selectedField === 'travellers') {
                <div class="bg-white rounded-3xl w-[290px] p-[1.6rem] absolute round-shadow z-[99] right-0" #paxdetails
                  [ngClass]="paxPopAbove?'bottom-[80px]':'top-[80px]'">
                  <app-add-traveller-modal class="text-black"
                    [paxData]="{ data: this.formGroup.value, roomdata: this.roomData }"
                    (OnClose)="patchPaxData($event)"></app-add-traveller-modal>
                </div>
                }
              </div>
            </div>
            <div class="flex justify-center items-center py-1" (mouseover)="SetDefaultDate()">
              <button mat-flat-button class="w-full py-[26px] rounded-lg primary-bg insurance-search-button"
                (click)="detail()">
                <span class="white-text font-medium text-[17px]">Search</span>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
}
<!--Theme 6-->
@case (themes.theme6) {
<div class="flex flex-col justify-center w-full items-center mobile:hidden tablet:hidden">
  <div class="bg-cover flex flex-col bg-center bg-no-repeat h-[400px] primary-bg w-full gray-text" style="background-image: url('{{insuranceData?.background_image}}');background-blend-mode: color !important;
background-color: #0000007a !important;">
    <div class="flex flex-col h-full items-center justify-center max-h-[18rem]">
      <div class="flex flex-col">
        <div class="flex">
          <h1
            class="text-center text-[52px] justify-center font-bold font-Racing_Sans_One white-text flex w-full z-[99] tracking-[4px]">
            {{insuranceData?.title}}</h1>
        </div>
        <div class="flex text-xl justify-center font-Ibm_Plex_Sans_Devanagari white-text">
          <div class="text-center w-[1000px] z-[99] textNote4">
            {{insuranceData?.description}}</div>
        </div>
      </div>
    </div>
  </div>
  <div class="pt-3">
    <div class="min-w-[1260px] max-w-[1260px] m-auto mt-[-62px] relative z-[99]">
      <div class="m-auto rounded-[10px]">
        <form [formGroup]="formGroup" class="flex flex-col rounded-[10px]">
          <div class="flex flex-row w-full white-bg overflow-visible h-[100px] rounded-[65px] shadow-xl">
            <div class="flex flex-row w-full">
              <div class="flex flex-col  border-r gray-border justify-center pl-13 cursor-pointer"
                [ngClass]="selectedField == 'destination' ? 'secondary-bg' : ''">
                <span class="font-normal text-[15px] font-Roboto text-secondary">Destination</span>
                <mat-select (click)="selectedField = 'destination'" #Destination
                  class="custom_dropdown_arrow pt-1 w-[228px] font-bold rounded-[5px] pr-[15px] pl-[15xp] text-xl"
                  formControlName="country_code" [compareWith]="compareWith">
                  <mat-option>
                    <ngx-mat-select-search placeholderLabel="Search Destination"
                      noEntriesFoundLabel="'no matching destination found'" formControlName="destinationfilter">
                    </ngx-mat-select-search>
                  </mat-option>
                  @for (ct of countryList; track ct) {
                  <mat-option [value]="ct">
                    <div class="flex flex-col truncate max-w-full justify-center">
                      <span class="font-normal text-base">{{ct.description}}
                      </span>
                    </div>
                  </mat-option>
                  }
                </mat-select>
              </div>
              <div class="flex flex-col pl-[11px] w-[150px] border-r gray-border justify-center cursor-pointer"
                (click)="picker2.open()" [ngClass]="selectedField == 'depart_date_time' ? 'secondary-bg' : ''">
                <div class="">
                  <mat-label class="white-text text-[15px] items-center gap-1 flex">
                    <span class="pt-1 pb-1 pr-1"><img loading="lazy" class="w-5" src="assets/images/b2c/date_icon.webp"
                        alt="date_icon"></span>
                    <span class="ml-0 pr-3 pt-[2px] text-secondary">Start Date</span>
                  </mat-label>
                  <input readonly class="font-Roboto font-bold text-xl pt-0.5 cursor-pointer max-w-[135px]" matInput
                    [matDatepicker]="picker2" [min]="minDate"
                    (click)="picker2.open();selectedField = 'depart_date_time'" formControlName="depart_date_time"
                    (dateChange)="onDateTimeChange($event, 'departDate')">
                  <mat-datepicker-toggle matSuffix [for]="picker2" class="hidden"></mat-datepicker-toggle>
                  <mat-datepicker #picker2></mat-datepicker>
                </div>
              </div>
              <div class="flex flex-col pl-[11px] w-[150px] border-r gray-border justify-center cursor-pointer"
                [ngClass]="selectedField == 'return_date_time' ? 'secondary-bg' : ''" (click)="pickerOne.open()">
                <div class="">
                  <mat-label class="white-text text-[15px] items-center gap-1 flex">
                    <span class="pt-1 pb-1 pr-1"><img loading="lazy" class="w-5" src="assets/images/b2c/date_icon.webp"
                        alt="date_icon"></span>
                    <span class="ml-0 pr-3 pt-[2px] text-secondary">End Date</span>
                  </mat-label>
                  <input readonly class="font-Roboto font-bold text-xl pt-0.5 cursor-pointer max-w-[135px]" matInput
                    [matDatepicker]="pickerOne" [min]="minDateReturn"
                    (click)="pickerOne.open();selectedField = 'return_date_time'" formControlName="return_date_time"
                    (dateChange)="onDateTimeChange($event, 'returnDate')">
                  <mat-datepicker-toggle matSuffix [for]="pickerOne" class="hidden"></mat-datepicker-toggle>
                  <mat-datepicker #pickerOne></mat-datepicker>
                </div>
              </div>
              <div class="flex flex-col white-text pl-2.5 min-w-[230px] justify-center border-r gray-border"
                [ngClass]="selectedField == 'duration' ? 'secondary-bg' : ''">
                <span class="font-normal text-[15px] font-Roboto text-secondary">Duration</span>
                <input appDurationChange formControlName="duration" (click)="selectedField = 'duration'" matInput
                  [value]="travelDuration" class="font-bold theme-black-text text-xl" />
              </div>
              <div class="min-w-[250px] flex flex-col pl-2.5 justify-center traveller-div cursor-pointer relative"
                [ngClass]="selectedField == 'travellers' ? 'secondary-bg' : ''" #containerRef>
                <div class="flex flex-col flex-grow justify-center traveller-div cursor-pointer" #travellerRef
                  (click)="openTraveller()">
                  <span class="text-[15px] rounded-lg w-full h-[24px] text-secondary">Travellers</span>
                  <div class="truncate pr-3 w-full rounded-md font-Roboto font-bold text-xl pt-0.5 cursor-pointer">
                    {{formGroup.get('age_list').value?.length ?
                    formGroup.get('age_list').value.length + ' Pax' :
                    'Select Traveller' }}
                  </div>
                </div>
                @if (selectedField === 'travellers') {
                <div class="bg-white rounded-3xl w-[290px] p-[1.6rem] absolute round-shadow z-[99] right-[-40px]"
                  #paxdetails [ngClass]="paxPopAbove?'bottom-[105px]':'top-[110px]'">
                  <app-add-traveller-modal class="text-black"
                    [paxData]="{ data: this.formGroup.value, roomdata: this.roomData }"
                    (OnClose)="patchPaxData($event)"></app-add-traveller-modal>
                </div>
                }
              </div>
              <div class="w-full h-full justify-end pr-5 flex items-center" (mouseover)="SetDefaultDate()">
                <button class="primary-bg rounded-full py-8 px-13 insurance-search-button" mat-flat-button
                  (click)="detail()">
                  <span class="font-normal text-white text-2xl font-Roboto">Search</span>
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
}
<!--Theme 7 -->
@case (themes.theme7) {
<div class="flex flex-col w-full items-center mobile:hidden tablet:hidden relative h-[635px]">
  <div class="absolute top-[-73px] w-full h-[710px] z-10"
    [style]="'background-image: url('+insuranceData?.background_image+');background-blend-mode: color !important; background-color: rgb(0 0 0 / 70%) !important; background-repeat: no-repeat;background-size: cover;background-position: center;'">
  </div>
  <div class="bg-cover flex flex-col bg-center bg-no-repeat h-[475px] primary-bg w-full gray-text">
    <div class="flex flex-col h-full items-center justify-center max-h-[14rem] mt-[73px]">
      <div class="flex flex-col">
        <div class="flex">
          <h1
            class="text-center text-[52px] justify-center font-normal leading-[65px] font-[ui-serif] white-text flex w-full z-[99]">
            {{insuranceData?.title}}</h1>
        </div>
        <div class="flex text-xl justify-center font-Ibm_Plex_Sans_Devanagari white-text">
          <div class="text-center w-[1000px] z-[99] textNote4">
            {{insuranceData?.description}}</div>
        </div>
      </div>
    </div>
  </div>
  <div class="min-w-[1260px] max-w-[1260px] z-[99] flex rounded-xl mt-[-100px]">
    <div class="mr-6 rounded-b-xl min-w-[1260px] max-w-[1260px]">
      <form [formGroup]="formGroup"
        class="flex flex-col p-5 pb-1.5 pt-2 white-bg rounded-b-xl shadow-xl theme7-form-field">
        <div class="flex flex-row w-full space-x-3 mt-3 mb-5">
          <mat-form-field class="min-w-[25%] max-w-[25%]">
            <mat-label class="text-secondary text-lg font-normal">Destination</mat-label>
            <mat-select class="font-medium text-[17px] h-[60px]" [compareWith]="compareWith"
              formControlName="country_code">
              <mat-option>
                <ngx-mat-select-search placeholderLabel="Search Destination"
                  noEntriesFoundLabel="'no matching destination found'" formControlName="destinationfilter">
                </ngx-mat-select-search>
              </mat-option>
              @for (ct of countryList; track ct) {
              <mat-option [value]="ct">
                <div class="flex flex-col truncate max-w-full h-15 justify-center">
                  <span class="font-normal text-base">
                    {{ct.description}}</span>
                </div>
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field class="w-[10%] min-w-[10%]">
            <mat-label class="text-secondary text-lg font-normal">Start Date</mat-label>
            <input matInput class="font-medium text-[17px] h-[60px]" [min]="minDate" (click)="picker.open()"
              [readonly]="true" [matDatepicker]="picker" formControlName="depart_date_time"
              (dateChange)="onDateTimeChange($event, 'departDate')" />
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
          <mat-form-field class="w-[10%] min-w-[10%]">
            <mat-label class="text-secondary text-lg font-normal">End Date</mat-label>
            <input matInput class="font-medium text-[17px] h-[60px]" [min]="minDateReturn" (click)="picker2.open()"
              [readonly]="true" [matDatepicker]="picker2" (dateChange)="onDateTimeChange($event, 'returnDate')"
              formControlName="return_date_time" />
            <mat-datepicker #picker2></mat-datepicker>
          </mat-form-field>
          <mat-form-field class="min-w-[16%] max-w-[16%]">
            <mat-label class="text-secondary text-lg font-normal">Duration</mat-label>
            <input appDurationChange formControlName="duration" class="font-medium text-[17px] h-[60px]" matInput
              [value]="travelDuration" />
          </mat-form-field>
          <div class="flex flex-col w-full traveller-div relative" #containerRef>
            <div class="flex flex-col w-full cursor-pointer" (click)="openTraveller()" #travellerRef>
              <span class="text-secondary text-lg font-normal pb-[3px] leading-[21px]">Travellers</span>
              <span
                class="font-medium text-[17px] cursor-pointer rounded-[10px] border-[1px] pt-[18px] pb-[17px] px-4 flex flex-row justify-between"
                [ngClass]="selectedField === 'travellers' ? 'border-[#4f46e5]' :'border-[#c2c2c799]'">
                {{formGroup.get('age_list').value?.length ?
                formGroup.get('age_list').value.length + ' Pax' :
                'Select Traveller' }}
              </span>
            </div>
            @if (selectedField === 'travellers') {
            <div class="bg-white rounded-3xl w-[290px] p-[1.6rem] absolute round-shadow z-[99] right-0" #paxdetails
              [ngClass]="paxPopAbove?'bottom-[100px]':'top-[100px]'">
              <app-add-traveller-modal class="text-black"
                [paxData]="{ data: this.formGroup.value, roomdata: this.roomData }"
                (OnClose)="patchPaxData($event)"></app-add-traveller-modal>
            </div>
            }
          </div>
          <div class="flex justify-center items-end pl-1" (mouseover)="SetDefaultDate()">
            <button mat-flat-button class="w-36 min-h-[65px] rounded-lg primary-bg insurance-search-button"
              (click)="detail()">
              <span class="white-text font-medium text-2xl">Search</span>
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
}
<!--Theme 8 -->
@case (themes.theme8) {
<div class="flex flex-col w-full items-center mobile:hidden tablet:hidden relative h-[575px]">
  <div class="absolute top-[-73px] w-full h-[650px] z-10"
    [style]="'background-image: url('+insuranceData?.background_image+');background-blend-mode: color !important; background-color: rgb(0 0 0 / 70%) !important; background-repeat: no-repeat;background-size: cover;background-position: center;'">
  </div>
  <div class="bg-cover flex flex-col bg-center bg-no-repeat h-[475px] primary-bg w-full gray-text">
    <div class="flex flex-col h-full items-center justify-center max-h-[14.5rem] mt-[120px]">
      <div class="flex flex-col">
        <div class="flex">
          <h1 class="text-center text-[41px] justify-center font-normal leading-[65px] white-text flex w-full z-[99]">
            {{insuranceData?.title}}</h1>
        </div>
        <div class="flex text-xl justify-center font-Ibm_Plex_Sans_Devanagari white-text">
          <div class="text-center w-[1000px] z-[99] textNote4">
            {{insuranceData?.description}}</div>
        </div>
      </div>
    </div>
  </div>
  <div class="min-w-[1260px] max-w-[1260px] z-[99] flex rounded-2xl mt-[-100px]">
    <div class="mr-6 rounded-2xl min-w-[1260px] max-w-[1260px]">
      <form [formGroup]="formGroup" class="flex flex-col rounded-2xl bg-[#0a0707ab] border light-border px-5 py-6">
        <div class="flex flex-row w-full rounded-[5px] white-bg">
          <div class="flex flex-row w-full">
            <div class="flex flex-col justify-center border-r gray-border cursor-pointer"
              [ngClass]="selectedField == 'destination' ? 'secondary-bg' : ''" (click)="Destination.open()">
              <span class="font-normal text-[15px] ml-6 font-Roboto text-secondary">Destination</span>
              <mat-select (click)="selectedField = 'destination'" #Destination
                class="ml-[22px] custom_dropdown_arrow pt-1 w-[273px] rounded-[5px] pr-[15px] pl-[15xp] font-Roboto font-medium text-xl"
                formControlName="country_code" [compareWith]="compareWith">
                <mat-option>
                  <ngx-mat-select-search placeholderLabel="Search Destination"
                    noEntriesFoundLabel="'no matching destination found'" formControlName="destinationfilter">
                  </ngx-mat-select-search>
                </mat-option>
                @for (ct of countryList; track ct) {
                <mat-option [value]="ct">
                  <div class="flex flex-col truncate max-w-full justify-center">
                    <span class="font-normal text-base">{{ct.description}}
                    </span>
                  </div>
                </mat-option>
                }
              </mat-select>
            </div>
            <div class="flex flex-col pl-2 justify-center w-[170px] border-r gray-border h-[75px] cursor-pointer"
              [ngClass]="selectedField == 'depart_date_time' ? 'secondary-bg' : ''" (click)="picker2.open()">
              <div class="ml-[7px]">
                <mat-label class="white-text text-[15px] items-center gap-1 flex">
                  <span class="pt-1 pb-1 pr-1"><img loading="lazy" class="w-5" src="assets/images/b2c/date_icon.webp"
                      alt="date_icon"></span>
                  <span class="ml-0 pr-3 pt-[2px] font-Roboto text-[15px] text-secondary font-normal">Start
                    Date</span>
                </mat-label>
                <input readonly class="font-Roboto font-medium text-xl cursor-pointer max-w-[135px]" matInput
                  [matDatepicker]="picker2" [min]="minDate" (click)="picker2.open();selectedField = 'depart_date_time'"
                  formControlName="depart_date_time" (dateChange)="onDateTimeChange($event, 'departDate')">
                <mat-datepicker-toggle matSuffix [for]="picker2" class="hidden"></mat-datepicker-toggle>
                <mat-datepicker #picker2></mat-datepicker>
              </div>
            </div>
            <div class="flex flex-col pl-2 justify-center w-[170px] border-r gray-border cursor-pointer"
              [ngClass]="selectedField == 'return_date_time' ? 'secondary-bg' : ''" (click)="pickerOne.open()">
              <div class="ml-[7px]">
                <mat-label class="items-center gap-1 flex">
                  <span class="pt-1 pb-1 pr-1"><img loading="lazy" class="w-5" src="assets/images/b2c/date_icon.webp"
                      alt="date_icon"></span>
                  <span class="ml-0 pr-3 pt-[2px] font-Roboto text-[15px] text-secondary font-normal">End
                    Date</span>
                </mat-label>
                <input readonly class="font-Roboto font-medium text-xl cursor-pointer max-w-[135px]" matInput
                  [matDatepicker]="pickerOne" [min]="minDateReturn"
                  (click)="pickerOne.open();selectedField = 'return_date_time'" formControlName="return_date_time"
                  (dateChange)="onDateTimeChange($event, 'returnDate')">
                <mat-datepicker-toggle matSuffix [for]="pickerOne" class="hidden"></mat-datepicker-toggle>
                <mat-datepicker #pickerOne></mat-datepicker>
              </div>
            </div>
            <div class="flex flex-col white-text min-w-[178px] justify-center pl-4 border-r gray-border"
              [ngClass]="selectedField == 'duration' ? 'secondary-bg' : ''">
              <span class="font-Roboto text-[15px] text-secondary font-normal">Duration</span>
              <input appDurationChange formControlName="duration" (click)="selectedField = 'duration'" matInput
                [value]="travelDuration" class="font-medium text-black pr-[15px] pl-[15xp] text-xl" />
            </div>
            <div class="min-w-[250px] flex flex-col pl-4 justify-center traveller-div relative"
              [ngClass]="selectedField == 'travellers' ? 'secondary-bg' : ''" #containerRef>
              <div class="flex flex-col flex-grow justify-center cursor-pointer" #travellerRef
                (click)="openTraveller()">
                <span class="font-Roboto text-[15px] text-secondary font-normal w-full h-[24px]">Travellers</span>
                <div class="truncate pr-3 w-full rounded-md font-Roboto font-medium text-xl cursor-pointer">
                  {{formGroup.get('age_list').value?.length ?
                  formGroup.get('age_list').value.length + ' Pax' :
                  'Select Traveller' }}
                </div>
              </div>
              @if (selectedField === 'travellers') {
              <div class="bg-white rounded-3xl w-[290px] p-[1.6rem] absolute round-shadow z-[99] right-0" #paxdetails
                [ngClass]="paxPopAbove?'bottom-[80px]':'top-[80px]'">
                <app-add-traveller-modal class="text-black" [paxData]="{ data: this.formGroup.value, roomdata: this.roomData }"
                  (OnClose)="patchPaxData($event)"></app-add-traveller-modal>
              </div>
              }
            </div>
            <div class="h-[75px] w-[192px] min-w-[192px] min-h-[75px] justify-end flex items-center"
              (mouseover)="SetDefaultDate()">
              <button class="primary-bg rounded-none rounded-r-[4px] h-[75px] min-h-[75px] w-full insurance-search-button"
                mat-flat-button (click)="detail()">
                <span class="white-text font-normal text-2xl font-Roboto">Search</span>
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
}
<!--Theme 9 -->
@case (themes.theme9) {
<div class="flex flex-col justify-center w-full items-center mobile:hidden tablet:hidden h-[635px]">
  <div class="absolute top-[-73px] w-full h-[600px] z-10"
    [style]="'background-image: url('+insuranceData?.background_image+');background-blend-mode: color !important; background-color: #000000bd !important; background-repeat: no-repeat;background-size: cover;background-position: center;'">
  </div>
  <div class="bg-cover flex flex-col bg-center bg-no-repeat h-[352px] primary-bg w-full gray-text">
    <div class="flex flex-col h-full items-center justify-center max-h-[14.5rem]">
      <div class="flex flex-col">
        <div class="flex">
          <h1 class="text-center text-[46px] justify-center font-semibold white-text flex w-full z-[99]">
            {{insuranceData?.title}}
          </h1>
        </div>
        <div class="flex text-xl justify-center font-normal font-Ibm_Plex_Sans_Devanagari white-text">
          <div class="text-center w-[1000px] z-[99] textNote4">
            {{insuranceData?.description}}</div>
        </div>
      </div>
    </div>
  </div>
  <div class="min-w-[1260px] max-w-[1260px] z-[99] flex rounded-[12px]">
    <div class="mr-6 rounded-[12px] min-w-[1260px] max-w-[1260px]">
      <form [formGroup]="formGroup" class="flex flex-col px-4 pt-[6px] white-bg rounded-[12px] shadow-xl pb-5">
        <div class="flex flex-row w-full space-x-3 mt-3 mb-5">
          <div class="flex flex-col min-w-[28%] max-w-[28%] h-[74px] py-3 pr-2 pl-[17px] cursor-pointer"
            (click)="Destination.open()">
            <span class="text-lg pr-[8px] max-w-max font-normal text-secondary">Destination</span>
            <mat-select class="mt-1 pr-2 font-medium text-xl" formControlName="country_code" #Destination
              [compareWith]="compareWith">
              <mat-option>
                <ngx-mat-select-search placeholderLabel="Search Destination"
                  noEntriesFoundLabel="'no matching destination found'" formControlName="destinationfilter">
                </ngx-mat-select-search>
              </mat-option>
              @for (ct of countryList; track ct) {
              <mat-option [value]="ct">
                <div class="flex flex-col truncate max-w-full h-15 justify-center">
                  <span class="font-normal text-base">{{ct.description}}
                  </span>
                </div>
              </mat-option>
              }
            </mat-select>
            <div class="gray-border mt-[3px] w-full border-t-2"></div>
          </div>
          <div class="flex flex-col w-[22%] h-[74px] px-3 py-2.5 cursor-pointer" (click)="picker.open()">
            <span class="max-w-max text-secondary text-lg font-normal">Start Date</span>
            <div class="flex flex-row">
              <input class="font-medium text-xl mt-1 max-w-[140px]" [min]="minDate" (click)="picker.open()"
                [readonly]="true" [matDatepicker]="picker" formControlName="depart_date_time"
                (dateChange)="onDateTimeChange($event, 'departDate')" />
            </div>
            <mat-datepicker #picker></mat-datepicker>
            <div class="gray-border mt-[3px] w-full border-t-2"></div>
          </div>
          <div class="flex flex-col w-[22%] h-[74px] px-3 py-2.5 cursor-pointer" (click)="pickerOne.open()">
            <span class="max-w-max text-secondary text-lg font-normal">End Date</span>
            <div class="flex flex-row">
              <input class="font-medium text-xl mt-1 max-w-[140px]" [min]="minDateReturn" (click)="pickerOne.open()"
                [readonly]="true" (dateChange)="onDateTimeChange($event, 'returnDate')" [matDatepicker]="pickerOne"
                formControlName="return_date_time" />
            </div>
            <mat-datepicker #pickerOne></mat-datepicker>
            <div class="gray-border mt-[3px] w-full border-t-2"></div>
          </div>
          <div class="flex flex-col min-w-[20%] max-w-[20%] h-[74px] py-3 px-2">
            <span class="text-lg px-[8px] max-w-max font-normal text-secondary">Duration</span>
            <input appDurationChange formControlName="duration" (click)="selectedField = 'duration'" matInput
              [value]="travelDuration" class="text-black mt-1 pl-2 font-medium primary-text text-xl" />
            <div class="gray-border mt-[1px] ml-2 w-full border-t-2"></div>
          </div>
          <div class="min-w-[20%] max-w-[20%] relative" #containerRef>
            <div
              class="flex flex-col flex-grow px-3 justify-end pt-2.5 h-[74px] min-w-[100%] max-w-[100%] traveller-div cursor-pointer"
              #travellerRef (click)="openTraveller()">
              <span class="max-w-max text-secondary text-lg font-normal pb-1">Travellers</span>
              <span class="font-medium text-xl cursor-pointer">
                {{formGroup.get('age_list').value?.length ?
                formGroup.get('age_list').value.length + ' Pax' :
                'Select Traveller' }}</span>
              <div class="gray-border mt-[3px] w-full mb-1 border-t-2"></div>
            </div>
            @if (selectedField === 'travellers') {
            <div class="bg-white rounded-3xl w-[290px] p-[1.6rem] absolute round-shadow z-[99] right-0" #paxdetails
              [ngClass]="paxPopAbove?'bottom-[80px]':'top-[80px]'">
              <app-add-traveller-modal class="text-black"
                [paxData]="{ data: this.formGroup.value, roomdata: this.roomData }"
                (OnClose)="patchPaxData($event)"></app-add-traveller-modal>
            </div>
            }
          </div>
        </div>
        <div class="flex flex-row justify-center items-center -mb-[42px] space-x-4" (mouseover)="SetDefaultDate()">
          <button mat-flat-button class="w-60 min-h-13 rounded-full primary-bg insurance-search-button"
            (click)="detail()">
            <span class="white-text font-medium text-2xl">Search</span>
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
}
<!--Theme 10 -->
@case (themes.theme10) {
<div class="flex flex-col justify-center w-full items-center mobile:hidden tablet:hidden relative">
  <div class="absolute top-0 w-full h-[375px] flex flex-row items-end">
    <div class="w-full min-h-full h-full relative">
      <div style="background-image: url(assets/images/b2c/theme_10_header_img.svg);
            background-repeat: no-repeat;
            background-position: right;
            background-size: cover;" class="z-10 min-h-full h-full w-[55%] absolute top-0 left-0"></div>
      <img loading="lazy" [src]="insuranceData?.background_image" alt="bg-img"
        class="object-cover bg-left h-full w-1/2 absolute top-0 right-0">
    </div>
  </div>
  <div class="flex flex-col bg-no-repeat h-[375px] bg-[#F9F9F9] w-full gray-text">
    <div class="flex flex-col min-w-[1260px] max-w-[1260px] m-auto h-full items-center justify-center">
      <div class="flex flex-col w-full">
        <div class="flex">
          <h1 class="text-[52px] justify-start font-bold font-Dosis theme-black-text flex w-[50%] z-[99] pr-2">
            {{insuranceData?.title}}
          </h1>
        </div>
        <div class="flex text-xl justify-start font-Ibm_Plex_Sans_Devanagari theme-black-text w-[50%] pr-2">
          <div class="w-full z-[99] textNote4">
            {{insuranceData?.description}}
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="min-w-[1260px] max-w-[1260px] z-[99] flex rounded-2xl mt-[-40px]">
    <div class="mr-6 rounded-2xl min-w-[1260px] max-w-[1260px]">
      <form [formGroup]="formGroup" class="flex flex-row white-bg rounded-[5px] overflow-visible shadow-xl">
        <div class="flex flex-row w-full overflow-visible rounded-[5px] white-bg">
          <div class="flex flex-row w-full">
            <div class="flex flex-col justify-center border-r gray-border cursor-pointer"
              [ngClass]="selectedField == 'country_code' ? 'secondary-bg' : ''" (click)="Destination.open()">
              <span class="font-normal text-[15px] ml-6 font-Roboto text-secondary">Destination</span>
              <mat-select (click)="selectedField = 'country_code'" #Destination
                class="ml-[22px] custom_dropdown_arrow pt-1 w-[273px] rounded-[5px] pr-[15px] pl-[15xp] font-Roboto font-medium text-xl"
                formControlName="country_code" [compareWith]="compareWith">
                <mat-option>
                  <ngx-mat-select-search placeholderLabel="Search Destination"
                    noEntriesFoundLabel="'no matching destination found'" formControlName="destinationfilter">
                  </ngx-mat-select-search>
                </mat-option>
                @for (ct of countryList; track ct) {
                <mat-option [value]="ct">
                  <div class="flex flex-col truncate max-w-full justify-center">
                    <span class="font-normal text-base">{{ct.description}}
                    </span>
                  </div>
                </mat-option>
                }
              </mat-select>
            </div>
            <div class="flex flex-col pl-2 justify-center w-[170px] border-r gray-border h-[75px] cursor-pointer"
              [ngClass]="selectedField == 'depart_date_time' ? 'secondary-bg' : ''" (click)="picker2.open()">
              <div class="ml-[7px]">
                <mat-label class="white-text text-[15px] items-center gap-1 flex">
                  <span class="pt-1 pb-1 pr-1"><img loading="lazy" class="w-5" src="assets/images/b2c/date_icon.webp"
                      alt="date_icon"></span>
                  <span class="ml-0 pr-3 pt-[2px] font-Roboto text-[15px] text-secondary font-normal">Start
                    Date</span>
                </mat-label>
                <input readonly class="font-Roboto font-medium text-xl cursor-pointer max-w-[135px]" matInput
                  [matDatepicker]="picker2" [min]="minDate" (click)="picker2.open();selectedField = 'depart_date_time'"
                  formControlName="depart_date_time" (dateChange)="onDateTimeChange($event, 'departDate')">
                <mat-datepicker-toggle matSuffix [for]="picker2" class="hidden"></mat-datepicker-toggle>
                <mat-datepicker #picker2></mat-datepicker>
              </div>
            </div>
            <div class="flex flex-col pl-2 justify-center w-[170px] border-r gray-border cursor-pointer"
              [ngClass]="selectedField == 'return_date_time' ? 'secondary-bg' : ''" (click)="pickerOne.open()">
              <div class="ml-[7px]">
                <mat-label class="items-center gap-1 flex">
                  <span class="pt-1 pb-1 pr-1"><img loading="lazy" class="w-5" src="assets/images/b2c/date_icon.webp"
                      alt="date_icon"></span>
                  <span class="ml-0 pr-3 pt-[2px] font-Roboto text-[15px] text-secondary font-normal">End
                    Date</span>
                </mat-label>
                <input readonly class="font-Roboto font-medium text-xl cursor-pointer max-w-[135px]" matInput
                  [matDatepicker]="pickerOne" [min]="minDateReturn"
                  (click)="pickerOne.open();selectedField = 'return_date_time'" formControlName="return_date_time"
                  (dateChange)="onDateTimeChange($event, 'returnDate')">
                <mat-datepicker-toggle matSuffix [for]="pickerOne" class="hidden"></mat-datepicker-toggle>
                <mat-datepicker #pickerOne></mat-datepicker>
              </div>
            </div>
            <div class="flex flex-col white-text min-w-[178px] justify-center pl-4 border-r gray-border"
              [ngClass]="selectedField == 'duration' ? 'secondary-bg' : ''">
              <span class="font-Roboto text-[15px] text-secondary font-normal">Duration</span>
              <input appDurationChange formControlName="duration" (click)="selectedField = 'duration'" matInput
                [value]="travelDuration"
                class="pt-1 text-black font-medium rounded-[5px] pr-[15px] pl-[15xp] text-xl" />
            </div>
            <div class="min-w-[250px] flex flex-col pl-4 justify-center traveller-div relative"
              [ngClass]="selectedField == 'travellers' ? 'secondary-bg' : ''" #containerRef>
              <div class="flex flex-col flex-grow justify-center cursor-pointer" #travellerRef
                (click)="openTraveller()">
                <span class="font-Roboto text-[15px] text-secondary font-normal w-full h-[24px]">Travellers</span>
                <div class="truncate pr-3 w-full rounded-md font-Roboto font-medium text-xl cursor-pointer">
                  {{formGroup.get('age_list').value?.length ?
                  formGroup.get('age_list').value.length + ' Pax' :
                  'Select Traveller' }}
                </div>
              </div>
              @if (selectedField === 'travellers') {
              <div class="bg-white rounded-3xl w-[290px] p-[1.6rem] absolute round-shadow z-[99] right-0" #paxdetails
                [ngClass]="paxPopAbove?'bottom-[80px]':'top-[80px]'">
                <app-add-traveller-modal class="text-black"
                  [paxData]="{ data: this.formGroup.value, roomdata: this.roomData }"
                  (OnClose)="patchPaxData($event)"></app-add-traveller-modal>
              </div>
              }
            </div>
            <div class="h-[75px] min-w-[192px] w-full min-h-[75px] justify-end flex items-center"
              (mouseover)="SetDefaultDate()">
              <button class="primary-bg rounded-none h-[75px] min-h-[75px] w-full insurance-search-button"
                mat-flat-button (click)="detail()">
                <span class="white-text font-normal text-2xl font-Roboto">Search</span>
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
}
<!--Theme 11 -->
@case (themes.theme11) {
<div class="flex flex-col justify-center w-full items-center mobile:hidden tablet:hidden xl:px-10 px-0">
  <div
    class="bg-cover flex flex-col bg-center bg-no-repeat h-[580px] xl:rounded-[30px] rounded-none primary-bg w-full gray-text"
    style="background-image: url('{{insuranceData?.background_image}}');background-blend-mode: color !important;
background-color: #0000007a !important;">
    <div class="flex flex-col h-full items-center justify-center max-h-[14rem]">
      <div class="flex flex-col">
        <div class="flex">
          <h1 class="text-center text-[52px] justify-center font-bold font-Dosis white-text flex w-full z-[99]">
            {{insuranceData?.title}}</h1>
        </div>
        <div class="flex text-xl justify-center font-Ibm_Plex_Sans_Devanagari white-text">
          <div class="text-center w-[1000px] z-[99] textNote4">
            {{insuranceData?.description}}</div>
        </div>
      </div>
    </div>
  </div>
  <div class="min-w-[1260px] max-w-[1260px] flex rounded-xl mt-[-300px]">
    <div class="mr-6 rounded-xl min-w-[1260px] max-w-[1260px]">
      <form [formGroup]="formGroup" class="flex flex-col px-4 pt-18 white-bg pb-[18px] rounded-xl shadow-xl">
        <div class="flex flex-row w-full space-x-3 mt-3 mb-5">
          <div
            class="flex flex-col min-w-[28%] max-w-[28%] h-[74px] py-3 px-2 secondary-bg rounded-[4px] cursor-pointer"
            (click)="Destination.open()">
            <span class="text-lg secondary-bg px-[10px] max-w-max font-normal text-secondary">Destination</span>
            <mat-select class="mt-1 px-2 font-semibold text-xl" formControlName="country_code" #Destination
              [compareWith]="compareWith">
              <mat-option>
                <ngx-mat-select-search placeholderLabel="Search Destination"
                  noEntriesFoundLabel="'no matching destination found'" formControlName="destinationfilter">
                </ngx-mat-select-search>
              </mat-option>
              @for (ct of countryList; track ct) {
              <mat-option [value]="ct">
                <div class="flex flex-col truncate max-w-full h-15 justify-center">
                  <span class="font-normal text-base">{{ct.description}}
                  </span>
                </div>
              </mat-option>
              }
            </mat-select>
          </div>
          <div class="flex flex-col w-[22%] h-[74px] secondary-bg rounded-[4px] px-3 py-2.5 cursor-pointer"
            (click)="picker.open()">
            <span class="max-w-max secondary-bg text-secondary text-lg font-normal">Start
              Date</span>
            <div class="flex flex-row">
              <input class="font-semibold text-xl mt-1 max-w-[100px]" [min]="minDate" (click)="picker.open()"
                [readonly]="true" [matDatepicker]="picker" formControlName="depart_date_time"
                (dateChange)="onDateTimeChange($event, 'departDate')" />
            </div>
            <mat-datepicker #picker></mat-datepicker>
          </div>
          <div class="flex flex-col w-[22%] h-[74px] secondary-bg rounded-[4px] px-3 py-2.5 cursor-pointer"
            (click)="pickerOne.open()">
            <span class="max-w-max secondary-bg text-secondary text-lg font-normal">End
              Date</span>
            <div class="flex flex-row">
              <input class="font-semibold text-xl mt-1 max-w-[100px]" [min]="minDateReturn" (click)="pickerOne.open()"
                [readonly]="true" [matDatepicker]="pickerOne" formControlName="return_date_time"
                (dateChange)="onDateTimeChange($event, 'returnDate')" />
            </div>
            <mat-datepicker #pickerOne></mat-datepicker>
          </div>
          <div class="flex flex-col min-w-[20%] max-w-[20%] h-[74px] py-3 px-2 secondary-bg rounded-[4px]">
            <span class="text-lg secondary-bg px-[8px] max-w-max font-normal text-secondary">Duration</span>
            <div class="flex flex-row">
              <input appDurationChange formControlName="duration" matInput [value]="travelDuration"
                class="pl-2 font-semibold text-xl theme-black-text" />
            </div>
          </div>
          <div class="min-w-[20%] max-w-[20%] relative" #containerRef>
            <div
              class="flex flex-col min-w-[100%] max-w-[100%] h-[74px] py-3 px-2 secondary-bg rounded-[4px] traveller-div cursor-pointer"
              #travellerRef (click)="openTraveller()">
              <span class="text-lg secondary-bg px-[10px] max-w-max font-normal text-secondary">Travellers</span>
              <span class="pl-2 font-semibold text-xl mt-1 cursor-pointer">
                {{formGroup.get('age_list').value?.length ?
                formGroup.get('age_list').value.length + ' Pax' :
                'Select Traveller' }}</span>
            </div>
            @if (selectedField === 'travellers') {
            <div class="bg-white rounded-3xl w-[290px] p-[1.6rem] absolute round-shadow z-[99] right-0" #paxdetails
              [ngClass]="paxPopAbove?'bottom-[80px]':'top-[80px]'">
              <app-add-traveller-modal class="text-black"
                [paxData]="{ data: this.formGroup.value, roomdata: this.roomData }"
                (OnClose)="patchPaxData($event)"></app-add-traveller-modal>
            </div>
            }
          </div>
        </div>
        <div class="flex flex-row justify-center items-center -mb-11 pt-[20px] space-x-4"
          (mouseover)="SetDefaultDate()">
          <button mat-flat-button class="w-64 min-h-13 rounded-full primary-bg insurance-search-button"
            (click)="detail()">
            <span class="white-text font-medium text-2xl">Search</span>
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
}
<!--Theme 12 -->
@case (themes.theme12) {
<div class="flex flex-col w-full items-center mobile:hidden tablet:hidden relative h-[595px]">
  <div class="absolute top-[-73px] w-full h-[670px] z-10"
    [style]="'background-image: url('+insuranceData?.background_image+');background-blend-mode: color !important; background-repeat: no-repeat;background-size: cover;background-position: center;'">
  </div>
  <div class="bg-cover flex flex-col bg-center bg-no-repeat h-[475px] primary-bg w-full gray-text">
    <div class="flex flex-col h-full items-center justify-center max-h-[11rem] mt-[73px]">
      <div class="flex flex-col">
        <div class="flex">
          <h1
            class="text-center text-[42px] justify-center font-normal leading-[65px] font-[ui-serif] white-text flex w-full z-[99]">
            {{insuranceData?.title}}</h1>
        </div>
        <div class="flex text-xl justify-center font-Ibm_Plex_Sans_Devanagari white-text">
          <div class="text-center w-[1000px] z-[99] textNote3">
            {{insuranceData?.description}}</div>
        </div>
      </div>
    </div>
  </div>
  <div class="min-w-[1260px] max-w-[1260px] z-[99] flex rounded-xl mt-[-100px]">
    <div class="mr-6 rounded-xl min-w-[1260px] max-w-[1260px]">
      <form [formGroup]="formGroup"
        class="flex flex-col p-5 pt-3 pb-2.5 bg-[#000000bd] rounded-xl shadow-xl theme12-form-field">
        <div class="flex flex-row w-full space-x-3 mt-3 mb-5">
          <mat-form-field class="min-w-[30%] max-w-[30%]">
            <mat-label class="text-[15px] text-white font-normal">Destination</mat-label>
            <mat-select class="font-medium py-[16px] text-[15px] pr-1 max-w-[523px]" [compareWith]="compareWith"
              formControlName="country_code">
              <mat-option>
                <ngx-mat-select-search placeholderLabel="Search Destination"
                  noEntriesFoundLabel="'no matching destination found'" formControlName="destinationfilter">
                </ngx-mat-select-search>
              </mat-option>
              @for (ct of countryList; track ct) {
              <mat-option [value]="ct">
                <div class="flex flex-col truncate max-w-full h-15 justify-center">
                  <span class="font-normal text-base">
                    {{ct.description}}</span>
                </div>
              </mat-option>
              }
            </mat-select>
            <mat-icon svgIcon="feather:map-pin" class="icon-size-5 gray-text"></mat-icon>
          </mat-form-field>
          <mat-form-field class="w-[13%] min-w-[13%]">
            <mat-label class="text-[15px] text-white font-normal">Start Date</mat-label>
            <input matInput class="font-medium py-[16px] text-[15px]" [min]="minDate" (click)="picker.open()"
              [readonly]="true" [matDatepicker]="picker" formControlName="depart_date_time"
              (dateChange)="onDateTimeChange($event, 'departDate')" />
            <mat-datepicker #picker></mat-datepicker>
            <mat-icon svgIcon="feather:calendar" class="icon-size-5 gray-text" (click)="picker.open()"></mat-icon>
          </mat-form-field>
          <mat-form-field class="w-[13%] min-w-[13%]">
            <mat-label class="text-[15px] text-white font-normal">End Date</mat-label>
            <input matInput class="font-medium py-[16px] text-[15px]" [min]="minDateReturn" (click)="picker2.open()"
              [readonly]="true" [matDatepicker]="picker2" formControlName="return_date_time"
              (dateChange)="onDateTimeChange($event, 'returnDate')" />
            <mat-datepicker #picker2></mat-datepicker>
            <mat-icon svgIcon="feather:calendar" class="icon-size-5 gray-text" (click)="picker2.open()"></mat-icon>
          </mat-form-field>
          <mat-form-field class="min-w-[16%] max-w-[16%]">
            <mat-label class="text-white text-[15px] font-normal">Duration</mat-label>
            <input appDurationChange formControlName="duration" (click)="selectedField = 'duration'" matInput
              [value]="travelDuration" class="font-medium py-[16px] text-black text-[15px] w-[230px] pr-1" />
            <img loading="lazy" src="assets/images/b2c/length_of_stay.svg" alt="length_of_stay"
              class="h-5 w-5 gray-text">
          </mat-form-field>
          <div class="min-w-[17%] max-w-[17%] relative" #containerRef>
            <div class="flex flex-col h-[80px] min-w-[100%] max-w-[100%] traveller-div cursor-pointer" #travellerRef
              (click)="openTraveller()">
              <span class="text-[15px] font-normal pb-[4px] text-white leading-5">Travellers</span>
              <span
                class="font-medium text-[15px] cursor-pointer rounded-[9px] border-[1px] py-[1.05rem] bg-white px-4 flex flex-row justify-between"
                [ngClass]="selectedField === 'travellers' ? 'border-[#4f46e5]' :'border-[#737373]'">{{formGroup.get('age_list').value?.length
                ?
                formGroup.get('age_list').value.length + ' Pax' :
                'Select Traveller' }}
                <mat-icon svgIcon="feather:user" class="icon-size-5 gray-text"></mat-icon>
              </span>
            </div>
            @if (selectedField === 'travellers') {
            <div class="bg-white rounded-3xl w-[290px] p-[1.6rem] absolute round-shadow z-[99] right-[-80px]"
              #paxdetails [ngClass]="paxPopAbove?'bottom-[80px]':'top-[90px]'">
              <app-add-traveller-modal class="text-black"
                [paxData]="{ data: this.formGroup.value, roomdata: this.roomData }"
                (OnClose)="patchPaxData($event)"></app-add-traveller-modal>
            </div>
            }
          </div>
          <div class="flex justify-center items-end pl-1" (mouseover)="SetDefaultDate()">
            <button mat-flat-button
              class="w-[70px] min-w-[70px] min-h-[60px] rounded-lg primary-bg text-white insurance-search-button"
              (click)="detail()">
              <mat-icon svgIcon="feather:search" class="icon-size-8 font-light text-white"></mat-icon>
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
}
<!--Theme 13 -->
@case (themes.theme13) {
<div class="flex flex-col justify-center w-full items-center mobile:hidden tablet:hidden">
  <div class="bg-cover flex flex-col bg-center bg-no-repeat h-[560px] primary-bg w-full gray-text" style="border-bottom-left-radius: 100% 250px;
    border-bottom-right-radius: 100% 250px;
    border-bottom: 14px solid white;
    background-color: #0000007a !important;
    background-image: url('{{insuranceData?.background_image}}');
    background-blend-mode: color !important;">
    <div class="flex flex-col h-full items-center justify-center max-h-[30rem]">
      <div class="flex flex-col min-w-[1260px] max-w-[1260px]">
        <div class="flex">
          <h1 class="text-[50px] font-semibold font-[cursive] white-text flex w-full z-[99] tracking-[7px]">
            {{insuranceData?.title}}</h1>
        </div>
        <div class="flex text-[30px] font-extralight pt-3 font-Ibm_Plex_Sans_Devanagari white-text">
          <div class="w-[1000px] z-[99] textNote4 leading-[35px]">
            {{insuranceData?.description}}</div>
        </div>
      </div>
    </div>
  </div>
  <div class="min-w-[1260px] max-w-[1260px] z-[99] flex rounded-[12px] mt-[-145px]">
    <div class="mr-6 rounded-[12px] min-w-[1260px] max-w-[1260px]">
      <form [formGroup]="formGroup"
        class="flex flex-col px-5 pt-3 white-bg rounded-[12px] shadow-xl pb-5 theme12-form-field">
        <div class="flex flex-row w-full space-x-4 mt-3 mb-7">
          <mat-form-field class="min-w-[30%] max-w-[30%]">
            <mat-label class="text-[16px] unselected-text font-normal">Destination</mat-label>
            <mat-select class="font-medium py-[16px] text-[15px] pr-1 max-w-[523px]" [compareWith]="compareWith"
              formControlName="country_code">
              <mat-option>
                <ngx-mat-select-search placeholderLabel="Search Destination"
                  noEntriesFoundLabel="'no matching destination found'" formControlName="destinationfilter">
                </ngx-mat-select-search>
              </mat-option>
              @for (ct of countryList; track ct) {
              <mat-option [value]="ct">
                <div class="flex flex-col truncate max-w-full h-15 justify-center">
                  <span class="font-normal text-base">
                    {{ct.description}}</span>
                </div>
              </mat-option>
              }
            </mat-select>
            <mat-icon matPrefix svgIcon="feather:map-pin" class="icon-size-5 gray-text"></mat-icon>
          </mat-form-field>
          <mat-form-field class="w-[14%] min-w-[14%]">
            <mat-label class="text-[16px] unselected-text font-normal">Start Date</mat-label>
            <input matInput class="font-medium py-[16px] text-[15px]" [min]="minDate" (click)="picker.open()"
              [readonly]="true" [matDatepicker]="picker" formControlName="depart_date_time"
              (dateChange)="onDateTimeChange($event, 'departDate')" />
            <mat-datepicker #picker></mat-datepicker>
            <mat-icon matPrefix svgIcon="feather:calendar" class="icon-size-5 gray-text"
              (click)="picker.open()"></mat-icon>
          </mat-form-field>
          <mat-form-field class="w-[14%] min-w-[14%]">
            <mat-label class="text-[16px] unselected-text font-normal">End Date</mat-label>
            <input matInput class="font-medium py-[16px] text-[15px]" [min]="minDateReturn" (click)="picker2.open()"
              [readonly]="true" [matDatepicker]="picker2" formControlName="return_date_time"
              (dateChange)="onDateTimeChange($event, 'returnDate')" />
            <mat-datepicker #picker2></mat-datepicker>
            <mat-icon matPrefix svgIcon="feather:calendar" class="icon-size-5 gray-text"
              (click)="picker2.open()"></mat-icon>
          </mat-form-field>
          <mat-form-field class="min-w-[17%] max-w-[17%]">
            <mat-label class="unselected-text text-[16px] font-normal">Duration</mat-label>
            <input appDurationChange formControlName="duration" (click)="selectedField = 'duration'" matInput
              [value]="travelDuration" class="text-black font-medium py-[16px] text-[15px] w-[230px] pr-1" />
            <img loading="lazy" matPrefix src="assets/images/b2c/length_of_stay.svg" alt="length_of_stay"
              class="h-5 mr-[10px] w-5 gray-text">
          </mat-form-field>
          <div class="min-w-[20%] max-w-[20%] relative" #containerRef>
            <div class="flex flex-col h-[80px] min-w-[100%] max-w-[100%] traveller-div cursor-pointer" #travellerRef
              (click)="openTraveller()">
              <span class="text-[16px] font-normal pb-[4px] unselected-text leading-5">Travellers</span>
              <span
                class="font-medium text-[15px] cursor-pointer rounded-[9px] border-[1px] py-[16px] bg-white px-4 flex flex-row gap-3"
                [ngClass]="selectedField === 'travellers' ? 'border-[#4f46e5]' :'border-[#d2d2d2]'">
                <mat-icon svgIcon="feather:user" class="icon-size-5 gray-text"></mat-icon>
                {{formGroup.get('age_list').value?.length ?
                formGroup.get('age_list').value.length + ' Pax' :
                'Select Traveller' }}
              </span>
            </div>
            @if (selectedField === 'travellers') {
            <div class="bg-white rounded-3xl w-[290px] p-[1.6rem] absolute round-shadow z-[99] right-0" #paxdetails
              [ngClass]="paxPopAbove?'bottom-[85px]':'top-[90px]'">
              <app-add-traveller-modal class="text-black"
                [paxData]="{ data: this.formGroup.value, roomdata: this.roomData }"
                (OnClose)="patchPaxData($event)"></app-add-traveller-modal>
            </div>
            }
          </div>
        </div>
        <div class="flex flex-row justify-center items-center -mb-[50px] space-x-4" (mouseover)="SetDefaultDate()">
          <button mat-flat-button class="w-64 min-h-[60px] rounded-full primary-bg insurance-search-button"
            (click)="detail()">
            <span class="white-text font-medium text-2xl">Search</span>
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
}
<!--Theme 14 -->
@case (themes.theme14) {
<div class="flex flex-col justify-center w-full items-center mobile:hidden tablet:hidden">
  <div class="bg-cover flex flex-col bg-center bg-no-repeat h-[510px] primary-bg w-full gray-text" style="background-image: url('{{insuranceData?.background_image}}');background-blend-mode: color !important;
        background-color: #0000007a !important;">
    <div class="flex flex-col h-full items-center justify-center max-h-[24rem] pt-[70px]">
      <div class="flex flex-col min-w-[1260px] max-w-[1260px]">
        <div class="flex">
          <h1 class="text-[48px] font-medium white-text w-full z-[99]" style="font-family: sans-serif;">
            {{insuranceData?.title}}</h1>
        </div>
        <div class="flex text-[22px] font-normal font-Ibm_Plex_Sans_Devanagari white-text">
          <div class="w-[650px] z-[99] textNote4">
            {{insuranceData?.description}}</div>
        </div>
      </div>
    </div>
  </div>
  <div class="min-w-[1260px] max-w-[1260px] z-[99] flex mt-[-61px]">
    <div class="min-w-[1260px] max-w-[1260px] px-7 rounded-[18px] rounded-t-none white-bg shadow-xl">
      <form [formGroup]="formGroup" class="flex flex-col border-t-2 pt-4 pb-2">
        <div class="flex flex-row w-full space-x-3 mt-3 mb-5">
          <div
            class="flex flex-col min-w-[25%] max-w-[25%] h-[74px] py-3 px-3 border-[1px] rounded-[10px] gray-border cursor-pointer">
            <span class="px-1.5 max-w-max text-base font-medium text-secondary">Destination</span>
            <mat-select class="mt-1 px-1.5 font-semibold text-lg" formControlName="country_code" #Destination
              [compareWith]="compareWith">
              <mat-option>
                <ngx-mat-select-search placeholderLabel="Search Destination"
                  noEntriesFoundLabel="'no matching destination found'" formControlName="destinationfilter"
                  (input)="filterdestination($event.target.value)">
                </ngx-mat-select-search>
              </mat-option>
              @for (ct of countryList; track ct) {
              <mat-option [value]="ct">
                <div class="flex flex-col truncate max-w-full h-15 justify-center">
                  <span class="font-normal text-base">{{ct.description}}</span>
                </div>
              </mat-option>
              }
            </mat-select>
          </div>
          <div class="flex flex-col w-[14%] h-[74px] border-[1px] rounded-[10px] gray-border p-3 cursor-pointer"
            (click)="picker.open()">
            <div class="max-w-max w-full flex flex-row justify-between text-secondary text-base min-w-full font-medium">
              <span class="font-medium text-secondary">Start Date</span>
              <mat-icon svgIcon="mat_outline:date_range" class="gray-text icon-size-5 cursor-pointer"
                (click)="picker.open()"></mat-icon>
            </div>
            <div class="flex flex-row">
              <input matInput class="font-semibold text-lg mt-1.5 max-w-[120px]" [min]="minDate" (click)="picker.open()"
                [readonly]="true" [matDatepicker]="picker" formControlName="depart_date_time" />
            </div>
            <mat-datepicker #picker></mat-datepicker>
          </div>
          <div class="flex flex-col w-[20%] h-[74px] py-3 px-3 border-[1px] rounded-[10px] gray-border cursor-pointer"
            (click)="picker2.open()">
            <div class="max-w-max w-full flex flex-row justify-between text-secondary text-base min-w-full font-medium">
              <span class="font-medium text-secondary">End Date</span>
              <mat-icon svgIcon="mat_outline:date_range" class="gray-text icon-size-5 cursor-pointer"
                (click)="picker2.open()"></mat-icon>
            </div>
            <div class="flex flex-row">
              <input matInput class="font-medium text-lg mt-1.5" [min]="minDateReturn" (click)="picker2.open()"
                [readonly]="true" [matDatepicker]="picker2" formControlName="return_date_time"
                (dateChange)="onDateTimeChange($event, 'returnDate')" />
            </div>
            <mat-datepicker #picker2></mat-datepicker>
          </div>
          <div class="flex flex-col w-[20%] h-[74px] py-3 px-3 border-[1px] rounded-[10px] gray-border cursor-pointer">
            <div class="max-w-max w-full flex flex-row justify-between text-secondary text-base min-w-full font-medium">
              <span class="font-medium text-secondary">Duration</span>
            </div>
            <div class="flex flex-row">
              <input appDurationChange class="font-medium text-lg mt-1.5" formControlName="duration"
                (click)="selectedField = 'duration'" matInput [value]="travelDuration" />
              <!-- class="text-black font-medium py-[16px] text-[15px] w-[230px] pr-1"  -->
            </div>
          </div>
          <div class="min-w-[18%] max-w-[18%] relative" #containerRef>
            <div
              class="flex flex-col min-w-[100%] max-w-[100%] gap-1 py-3 px-3 border-[1px] rounded-[10px] traveller-div gray-border cursor-pointer "
              #travellerRef (click)="openTraveller()">
              <div
                class="max-w-max w-full flex flex-row justify-between text-secondary text-base min-w-full font-medium">
                <span class="font-medium text-secondary">Travellers</span>
              </div>
              <span class="font-medium text-[15px] cursor-pointer  bg-white  flex flex-row gap-3"
                [ngClass]="selectedField === 'travellers' ? 'border-[#4f46e5]' :'border-[#d2d2d2]'">
                <mat-icon svgIcon="feather:user" class="icon-size-5 gray-text"></mat-icon>
                {{formGroup.get('age_list').value?.length ?
                formGroup.get('age_list').value.length + ' Pax' :
                'Select Traveller' }}
              </span>
            </div>
            @if (selectedField === 'travellers') {
            <div class="bg-white rounded-3xl w-[290px] p-[1.6rem] absolute round-shadow z-[99] right-[-76px]"
              #paxdetails [ngClass]="paxPopAbove?'bottom-[80px]':'top-[80px]'">
              <app-add-traveller-modal class="text-black"
                [paxData]="{ data: this.formGroup.value, roomdata: this.roomData }"
                (OnClose)="patchPaxData($event)"></app-add-traveller-modal>
            </div>
            }
          </div>
          <div class="flex flex-row justify-center items-end" (mouseover)="SetDefaultDate()">
            <button mat-flat-button
              class="w-[73px] mb-0.5 min-w-[73px] min-h-[73px] rounded-lg primary-bg text-white insurance-search-button"
              (click)="detail()">
              <mat-icon svgIcon="feather:search" class="icon-size-8 font-light text-white"></mat-icon>
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
}
<!--Theme 15 -->
@case (themes.theme15) {
<div class="flex flex-col justify-center w-full items-center mobile:hidden tablet:hidden">
  <div class="bg-cover flex flex-col bg-center bg-no-repeat h-[650px] primary-bg w-full gray-text" style="background-image: url('{{insuranceData?.background_image}}');background-blend-mode: color !important;
      background-color: #0000007a !important;">
    <div class="flex flex-col h-full items-center justify-center max-h-[17rem] pt-[70px]">
      <div class="flex flex-col min-w-[1260px] max-w-[1260px]">
        <div class="flex">
          <h1 class="text-[48px] text-center font-semibold white-text w-full z-[99]" style="font-family: sans-serif;">
            {{insuranceData?.title}}</h1>
        </div>
        <div class="flex text-[20px] white-text justify-center">
          <div class="w-[900px] z-[99] font-light textNote2 text-center">
            {{insuranceData?.description}}</div>
        </div>
      </div>
    </div>
  </div>
  <div class="absolute top-[335px] left-0 right-0 min-h-fit flex w-full justify-center">
    <div class="min-w-[1260px] max-w-[1260px] z-[99] flex">
      <div class="min-w-[1260px] max-w-[1260px] px-7 rounded-[18px] white-bg shadow-xl"
        [ngClass]="{ 'rounded-tl-none' : isFirstService }">
        <form [formGroup]="formGroup" class="flex flex-col  pt-6 pb-2">
          <div class="flex flex-row w-full space-x-3 mt-3 mb-5">
            <div
              class="flex flex-col min-w-[25%] max-w-[25%] h-[74px] py-3 px-3 border-[1px] rounded-[10px] gray-border cursor-pointer">
              <span class="px-1.5 max-w-max text-[15px] text-secondary font-normal">Destination</span>
              <mat-select class="mt-1 px-1.5 font-semibold text-lg" formControlName="country_code" #Destination
                [compareWith]="compareWith">
                <mat-option>
                  <ngx-mat-select-search placeholderLabel="Search Destination"
                    noEntriesFoundLabel="'no matching destination found'" formControlName="destinationfilter"
                    (input)="filterdestination($event.target.value)">
                  </ngx-mat-select-search>
                </mat-option>
                @for (ct of countryList; track ct) {
                <mat-option [value]="ct">
                  <div class="flex flex-col truncate max-w-full h-15 justify-center">
                    <span class="font-normal text-base">{{ct.description}}</span>
                  </div>
                </mat-option>
                }
              </mat-select>
            </div>
            <div
              class="flex flex-col w-[14%] min-w-[14%] max-w-[14%] h-[74px] border-[1px] rounded-[10px] gray-border p-3 cursor-pointer"
              (click)="picker.open()">
              <div
                class="max-w-max w-full flex flex-row justify-between text-secondary text-base min-w-full font-medium">
                <span class="text-[15px] text-secondary font-normal">Start Date</span>
              </div>
              <div class="flex flex-row">
                <input matInput class="font-semibold text-lg mt-1.5 max-w-[120px]" [min]="minDate"
                  (click)="picker.open()" [readonly]="true" [matDatepicker]="picker"
                  formControlName="depart_date_time" />
              </div>
              <mat-datepicker #picker></mat-datepicker>
            </div>
            <div
              class="flex flex-col w-[14%] min-w-[14%] max-w-[14%] h-[74px] py-3 px-3 border-[1px] rounded-[10px] gray-border cursor-pointer"
              (click)="picker2.open()">
              <div
                class="max-w-max w-full flex flex-row justify-between text-secondary text-base min-w-full font-medium">
                <span class="text-[15px] text-secondary font-normal">End Date</span>
              </div>
              <div class="flex flex-row">
                <input matInput class="font-medium text-lg mt-1.5" [min]="minDateReturn" (click)="picker2.open()"
                  [readonly]="true" [matDatepicker]="picker2" formControlName="return_date_time"
                  (dateChange)="onDateTimeChange($event, 'returnDate')" />
              </div>
              <mat-datepicker #picker2></mat-datepicker>
            </div>
            <div
              class="flex flex-col w-[14%] min-w-[14%] max-w-[14%] h-[74px] py-3 px-3 border-[1px] rounded-[10px] gray-border cursor-pointer">
              <div
                class="max-w-max w-full flex flex-row justify-between text-secondary text-base min-w-full font-medium">
                <span class="text-[15px] text-secondary font-normal">Duration</span>
              </div>
              <div class="flex flex-row">
                <input appDurationChange class="font-medium text-lg mt-1.5" formControlName="duration"
                  (click)="selectedField = 'duration'" matInput [value]="travelDuration" />
                <!-- class="text-black font-medium py-[16px] text-[15px] w-[230px] pr-1"  -->
              </div>
            </div>
            <div class="min-w-[17%] max-w-[17%] relative" #containerRef>
              <div
                class="flex flex-col min-w-[100%] max-w-[100%] gap-1 py-3 px-3 border-[1px] rounded-[10px] traveller-div gray-border cursor-pointer "
                #travellerRef (click)="openTraveller()">
                <div
                  class="max-w-max w-full flex flex-row justify-between text-secondary text-base min-w-full font-medium">
                  <span class="text-[15px] text-secondary font-normal">Travellers</span>
                </div>
                <span class="font-medium text-[15px] cursor-pointer  bg-white  flex flex-row gap-3"
                  [ngClass]="selectedField === 'travellers' ? 'border-[#4f46e5]' :'border-[#d2d2d2]'">
                  <mat-icon svgIcon="feather:user" class="icon-size-5 gray-text"></mat-icon>
                  {{formGroup.get('age_list').value?.length ?
                  formGroup.get('age_list').value.length + ' Pax' :
                  'Select Traveller' }}
                </span>
              </div>
              @if (selectedField === 'travellers') {
              <div class="bg-white rounded-3xl w-[290px] p-[1.6rem] absolute round-shadow z-[99] right-[-86px]"
                #paxdetails [ngClass]="paxPopAbove?'bottom-[80px]':'top-[80px]'">
                <app-add-traveller-modal class="text-black"
                  [paxData]="{ data: this.formGroup.value, roomdata: this.roomData }"
                  (OnClose)="patchPaxData($event)"></app-add-traveller-modal>
              </div>
              }
            </div>
            <div class="flex flex-row justify-center items-center" (mouseover)="SetDefaultDate()">
              <button mat-flat-button class="w-[130px] min-h-18 rounded-xl primary-bg insurance-search-button"
                (click)="detail()">
                <span class="white-text font-medium text-2xl">Search</span>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
}
<!--Theme 16 -->
@case (themes.theme16) {
<div class="flex flex-col justify-center w-full items-center mobile:hidden tablet:hidden">
  <div class="bg-cover flex flex-col bg-center bg-no-repeat h-[650px] primary-bg w-full gray-text" style="background-image: url('{{insuranceData?.background_image}}');background-blend-mode: color !important;
      background-color: #0000007a !important;">
    <div class="flex flex-col h-full items-center justify-center max-h-[17rem] pt-[70px]">
      <div class="flex flex-col justify-start min-w-[1260px] max-w-[1260px]">
        <h1 class="text-[48px] font-semibold white-text w-full z-[99] uppercase"
          style="font-family: 'Mina'; text-shadow: 2px 2px 4px rgba(0,0,0,0.4);">
          {{insuranceData?.title}}
        </h1>
        <div class="w-[900px] z-[99] text-[20px] white-text font-light textNote2"
          style="text-shadow: 1px 1px 3px rgba(0,0,0,0.3);">
          {{insuranceData?.description}}
        </div>
      </div>
    </div>
  </div>
  <div class="absolute top-[335px] left-0 right-0 min-h-fit flex w-full justify-center">
    <div class="min-w-[1260px] max-w-[1260px] z-[99] flex">
      <div class="min-w-[1260px] max-w-[1260px] bg-white/40 p-6 w-full backdrop-blur-md rounded-[20px] shadow-xl">
        <form [formGroup]="formGroup" class="flex flex-col">
          <div class="flex flex-row w-full space-x-3">
            <div class="flex flex-col min-w-[25%] w-full h-[74px] py-3 px-3 white-bg rounded-2xl cursor-pointer">
              <span class="px-1.5 max-w-max text-[15px] text-secondary font-normal">Destination</span>
              <mat-select class="mt-1 px-1.5 font-semibold text-lg" formControlName="country_code" #Destination
                [compareWith]="compareWith">
                <mat-option>
                  <ngx-mat-select-search placeholderLabel="Search Destination"
                    noEntriesFoundLabel="'no matching destination found'" formControlName="destinationfilter"
                    (input)="filterdestination($event.target.value)">
                  </ngx-mat-select-search>
                </mat-option>
                @for (ct of countryList; track ct) {
                <mat-option [value]="ct">
                  <div class="flex flex-col truncate max-w-full h-15 justify-center">
                    <span class="font-normal text-base">{{ct.description}}</span>
                  </div>
                </mat-option>
                }
              </mat-select>
            </div>
            <div class="flex flex-col min-w-[14%] w-full h-[74px] white-bg rounded-2xl p-3 cursor-pointer"
              (click)="picker.open()">
              <div
                class="max-w-max w-full flex flex-row justify-between text-secondary text-base min-w-full font-medium">
                <span class="text-[15px] text-secondary font-normal">Start Date</span>
              </div>
              <div class="flex flex-row">
                <input matInput class="font-semibold text-lg mt-1.5 max-w-[120px]" [min]="minDate"
                  (click)="picker.open()" [readonly]="true" [matDatepicker]="picker"
                  formControlName="depart_date_time" />
              </div>
              <mat-datepicker #picker></mat-datepicker>
            </div>
            <div class="flex flex-col min-w-[14%] w-full h-[74px] py-3 px-3 white-bg rounded-2xl cursor-pointer"
              (click)="picker2.open()">
              <div
                class="max-w-max w-full flex flex-row justify-between text-secondary text-base min-w-full font-medium">
                <span class="text-[15px] text-secondary font-normal">End Date</span>
              </div>
              <div class="flex flex-row">
                <input matInput class="font-medium text-lg mt-1.5" [min]="minDateReturn" (click)="picker2.open()"
                  [readonly]="true" [matDatepicker]="picker2" formControlName="return_date_time"
                  (dateChange)="onDateTimeChange($event, 'returnDate')" />
              </div>
              <mat-datepicker #picker2></mat-datepicker>
            </div>
            <div class="flex flex-col min-w-[14%] w-full h-[74px] py-3 px-3 white-bg rounded-2xl cursor-pointer">
              <div
                class="max-w-max w-full flex flex-row justify-between text-secondary text-base min-w-full font-medium">
                <span class="text-[15px] text-secondary font-normal">Duration</span>
              </div>
              <div class="flex flex-row">
                <input appDurationChange class="font-medium text-lg mt-1.5" formControlName="duration"
                  (click)="selectedField = 'duration'" matInput [value]="travelDuration" />
                <!-- class="text-black font-medium py-[16px] text-[15px] w-[230px] pr-1"  -->
              </div>
            </div>
            <div class="min-w-[17%] w-full relative" #containerRef>
              <div
                class="flex flex-col min-w-[100%] w-full gap-1 py-3 px-3 white-bg rounded-2xl traveller-div cursor-pointer "
                #travellerRef (click)="openTraveller()">
                <div
                  class="max-w-max w-full flex flex-row justify-between text-secondary text-base min-w-full font-medium">
                  <span class="text-[15px] text-secondary font-normal">Travellers</span>
                </div>
                <span class="font-medium text-[16px] cursor-pointer  bg-white  flex flex-row gap-3"
                  [ngClass]="selectedField === 'travellers' ? 'border-[#4f46e5]' :'border-[#d2d2d2]'">
                  <mat-icon svgIcon="feather:user" class="icon-size-5 gray-text"></mat-icon>
                  {{formGroup.get('age_list').value?.length ?
                  formGroup.get('age_list').value.length + ' Pax' :
                  'Select Traveller' }}
                </span>
              </div>
              @if (selectedField === 'travellers') {
              <div class="bg-white rounded-3xl w-[290px] p-[1.6rem] absolute round-shadow z-[99] right-[-84px]"
                #paxdetails [ngClass]="paxPopAbove?'bottom-[80px]':'top-[80px]'">
                <app-add-traveller-modal class="text-black"
                  [paxData]="{ data: this.formGroup.value, roomdata: this.roomData }"
                  (OnClose)="patchPaxData($event)"></app-add-traveller-modal>
              </div>
              }
            </div>
            <div class="flex flex-row justify-center items-start" (mouseover)="SetDefaultDate()">
              <button mat-flat-button class="rounded-xl min-h-[74px] primary-bg" (click)="detail()">
                <mat-icon class="text-white invert w-8 h-8" svgIcon="feather:search"></mat-icon>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
}
}
}
}